class FrameForestApp {
    constructor() {
        // Create global state and initialize core properties
        this.state = this.createGlobalState();
        this.initProperties();

    }

    // Initializes all app-level properties, limits, UI state,
    async initProperties() {

        if(!this.S$Q(".pafp-h_banner.tce.bgo")) {
            this.S$G("MainContent").style.marginTop = "unset"
        }
        
        // --- 1. Static mappings and state ---
        this.uploadIndex = null;
        this._reordering = false;
        this.addToCartInProcess = false;
        this.cartAddSucceeded = false;

        this.frames = [];
        this.blobs = new Map();      // url -> {id, blob, created, size}
        this.timers = new Set();     // timer IDs
        this.listeners = new Map();  // element -> [listeners]
        this.observers = new Set();
        this.intervals = new Set();
        this.animationFrames = new Set();

        this.IMAGE_STATUS = {
            PENDING: 'pending',
            UPLOADING: 'uploading',
            UPLOADED: 'uploaded',
            ERROR: 'error'
        };

        this.UPLOAD_QUEUE_STATUS = {
            WAITING: 'waiting',
            PROCESSING: 'processing',
            COMPLETED: 'completed',
            FAILED: 'failed'
        };

        this.limits = {
            maxBlobs: 100,
            maxBlobAge: 600000,      // 10 min
            maxMemoryMB: 500,        // 500 MB
            maxImageSize: 50 * 1024 * 1024, // 50 MB
            cleanupInterval: 300000  // 5 min
        };

        this.metrics = {
            totalBlobsCreated: 0,
            totalBlobsRevoked: 0,
            totalMemoryUsed: 0,
            totalCleanups: 0,
            memoryWarnings: 0,
            lastCleanup: null,
            peakMemoryUsage: 0
        };

        // --- 2. External / UI setup ---
        this.fileStack = filestack.init('Av52UkFmsQ1aDQgxjEjyrz');
        this.trimSpacing = 0.1;
        this.borderTBA = 0.2;
        this.frameBorder = 0.87;
        this.dpi = 300;

        // Device type detection
        this.dType = window.innerWidth <= 868 ? 'M' : 'D';
        this.eventType = this.dType === "D" ? "click" : "touchstart";
        this.boundHandlers = { zoomButtonHandlers: new Map() };
        this.handlersInitialized = false;
        this.ui = {};

        this.data = null;
        this.db = null;
        this.isSaving = false;
        this.queue = [];
        this.lastSaveTime = 0;
        this.minInterval = 500;
        this.isFallback = false;
        this.persistData = false;

        //  * Initial async bootstrapping
        await this.init();

        // * Restore selected configuration
        const frameSelected = document.querySelector(".pta_vp__frame-box").dataset.selectedFrame;
        const styleSelected = document.querySelector(".pta_vp__style-box").dataset.selectedStyle;
        const sizeSelected = document.querySelector(".pta_vp__size-box").dataset.selectedSize;
        this.updatePhotoToArtConfig(frameSelected, styleSelected, sizeSelected);

        // * UI initialization & rendering
        this.initElements();
        this.render();

        window.PhotoToArt.State = this.state;

        //  * Event binding & option rendering
        this.setupEventListenersG();
        this.renderFrameOptions();
        // this.renderStyleOptions(undefined, { skipSizeRender: true });
        // this.renderSizeOptions();
        this.buildFramesSummary();
    }

    /**
        * Updates the Photo-to-Art configuration
    **/
    updatePhotoToArtConfig(frameSelected, styleSelected, sizeSelected) {
        if (frameSelected) {
            if (frameSelected === "Framed Prints") {
                frameSelected = "Framed_photos";
            } else if (frameSelected === "Canvas Prints") {
                frameSelected = "Canvas";
            }
        }
        let newSize = `${frameSelected}_${styleSelected}_${sizeSelected}`;
        if (this.persistData) {
            styleSelected = this.photoToArt.style;
            sizeSelected = this.photoToArt.size;
            if (this.photoToArt.frame) {
                if (this.photoToArt.frame === "Framed Prints") {
                    frameSelected = "Framed_photos";
                } else if (frameSelected === "Canvas Prints") {
                    frameSelected = "Canvas";
                }
            }
        }

        sizeSelected = this.normalizeSize(sizeSelected)
        newSize = frameSelected === "Canvas" ? `${frameSelected}_${sizeSelected}` : `${frameSelected}_${styleSelected}_${sizeSelected}`;
        
        this.photoToArtVariantData = this.getVariantData(newSize);
        
        this.pu = this.getDefaultPu();

        // Update config based on new size
        if (!this.photoToArt) {
            // Create a fresh photoToArt object for new size
            this.photoToArt = this.createPhotoToArtObject({
                photoToArtId: this.generatePhotoToArtId(),
                layout: "grid",
                price: this.photoToArtVariantData?.price,
                size: sizeSelected,
                style: styleSelected,
                width: sizeSelected.split('x')[0],
                height: sizeSelected.split('x')[1],
                variantID: this.photoToArtVariantData?.id,
                frames: []
            });
        }

        if (!this.photoLabels) {
            this.photoLabels = Object.keys(Array(1).fill(0)).map((_, i) => `Photo ${i + 1}`);
        }
        if (!this.images) {
            this.images = Array(Object.keys(Array(1).fill(0)).length).fill(null);
        } else {
            const winLen = Object.keys(Array(1).fill(0)).length;
            if (this.images.length > winLen) {
                this.images = this.images.slice(0, winLen);
            } else if (this.images.length < winLen) {
                this.images = [
                    ...this.images,
                    ...Array(winLen - this.images.length).fill(null)
                ];
            }
        }

        if (!this.posToIndex) {
            this.posToIndex = {};
            for (let i = 0; i < Object.keys(Array(1).fill(0)).length; i++) {
                this.posToIndex[i] = i;
            }
        }

        // Recalculate scaling and dimensions
        this.calculateUIDimensions();

        // Apply updated state
        this.updateGState({
            posToIndex: this.posToIndex,
            photoLabels: this.photoLabels,
            images: this.images,
            // scaled: this.scaled, 
            // full: this.full,  
            photoToArt: this.photoToArt
        });
    }

    // Method to calculate and update UI dimensions
    calculateUIDimensions() {
        if (this.dType === "M") {
            const elHeight = selector => this.S$Q(selector)?.offsetHeight || 0;

            const bannerHeight = ['.pafp-h_banner'].reduce((sum, sel) => sum + elHeight(sel), 0);

            const headHeight = ['header.header', '.announcement-bar', '.pafp-h_banner'].reduce((sum, sel) => sum + elHeight(sel), 0);

            const orgHeadHeight = ['.pafp-h_banner', 'header.header', '.announcement-bar','.page-trail-container'].reduce((sum, sel) => sum + elHeight(sel), 0);

            this.ui.galHeight = window.innerHeight - ['.pafp-h_banner', 'header.header', '.pta_sidebar', '.announcement-bar', '.page-trail-container'].reduce((sum, sel) => sum + elHeight(sel), 0);

            this.ui.epuHeight = window.innerHeight - ['header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);

            this.ui.epuBodyHeight = this.ui.epuHeight - 160;
            this.ui.epuFooterHeight = this.ui.epuHeight - this.ui.epuBodyHeight;
            // this.S$Q(".product-gallery-img-inner").style.height = this.ui.galHeight + "px";
            // this.S$Q(".pta_wrapper").style.height = "200" + "px";
            const navHeight = window.screen.height - window.innerHeight;
            // this.S$Q(".pta_sbmd").style.paddingBottom = navHeight + "px";
            this.S$Q(".pta_epu-box").style.top = (headHeight - (bannerHeight * 0.35)) + "px";
            this.S$Q(".pta_delivery_info").style.top = (headHeight - bannerHeight) + "px";


            this.S$Q(".pta_epu-box").style.height = (this.ui.epuHeight + (bannerHeight * 0.35)) + "px";
            this.ui.editMidAreaAvail = (((this.ui.epuHeight + (bannerHeight * 0.35))  - this.ui.epuFooterHeight) * 0.5)
            // this.S$Q(".pta_epu-body").style.maxHeight = this.ui.epuBodyHeight + "px";
            // this.S$Q(".pta_epu-body").style.height = this.ui.epuBodyHeight + "px";
            this.S$Q(".pta_epu-footer").style.height = this.ui.epuFooterHeight + "px";
            document.documentElement.style.setProperty(`--total-header-height`, `${headHeight}px`);

            // Heights for fixed header elements
                const mainHeadHeight =
                elHeight('.pafp-h_banner') +
                elHeight('.page-trail-container');

                // Available vertical space for main area
                const mainEl = this.S$Q('.pta_main');
                const mainRect = mainEl.getBoundingClientRect();

                const availableSpace = this.ui.galHeight - mainRect.height;
                const ratio = availableSpace / mainRect.height;

                // Allow main area to grow, but cap the expansion
                const extraHeight = mainRect.height * Math.min(ratio, 0.5);
                const newHeight = mainRect.height + extraHeight;

                // Final height should never be smaller than gallery height
                const mainHeight = Math.max(newHeight, this.ui.galHeight);
                // mainEl.style.height = `${mainHeight}px`;

                // Inner gallery elements height adjustments
                const galleryInnerHeight = mainHeight - (mainHeadHeight + 32);
                const photoWrapperHeight = mainHeight - mainHeadHeight;
                
                // this.S$$('.pta_main .product-gallery-img .product-gallery-img-inner')
                // .forEach(el => el.style.height = `${galleryInnerHeight}px`);

                // this.S$$('.pta_main .product-gallery-img .flickity-viewport')
                // .forEach(el => el.style.height = `${galleryInnerHeight}px`);

                // this.S$$('.pta_main .product-photo-to-art-img-wrapper')
                // .forEach(el => el.style.height = `${photoWrapperHeight}px`);

                // Sidebar height adjustment (in vh)
                const remainingHeight =
                window.innerHeight - (orgHeadHeight + (mainRect.height - mainHeadHeight));

                const sidebarVh = (remainingHeight / window.innerHeight) * 100;

                if (sidebarVh > 0) {
                    // this.S$Q('.pta_sidebar').style.height = `${sidebarVh}vh`;
                }
            // }
        } else {
            const elHeight = selector => this.S$Q(selector)?.offsetHeight || 0;
            this.ui.headHeight = ['.pafp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
            this.ui.galHeight = window.innerHeight - ['.pafp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
            this.ui.epuHeight = window.innerHeight - ['.pafp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
            this.ui.epuBodyHeight = this.ui.epuHeight - 160;
            this.ui.epuFooterHeight = this.ui.epuHeight - this.ui.epuBodyHeight;
        }

    }

    // ================================================================
    // INITIALIZATION
    // ================================================================

    //  Dynamically loads the `idb` library if it is not already available. 
    async loadIdbLibrary() {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://unpkg.com/idb@7/build/umd.js';
            script.onload = () => {
                if (window.idb && typeof window.idb.openDB === 'function') {
                    resolve();
                } else {
                    reject(new Error('Failed to load idb library'));
                }
            };
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    // Initializes IndexedDB using the `idb` wrapper. 
    async initDB() {
        if (this.db || this.isFallback || window.db) {
            console.log('ℹ️ Database already initialized');
            return this.db || window.db || null;
        }

        console.log('🗄️ Pg.State: Initializing IndexedDB');

        try {
            //  * Environment & support checks
            if (!('indexedDB' in window)) throw new Error('IndexedDB not supported');
            
            // Load idb library dynamically if not available
            if (!window.idb || typeof window.idb.openDB !== 'function') {
                await this.loadIdbLibrary();
            }

            //  * Open / upgrade IndexedDB
            this.db = await window.idb.openDB('pgStateDB', 3, {
                upgrade(db, oldVersion, newVersion) {
                    if (!db.objectStoreNames.contains('appState')) {
                        const store = db.createObjectStore('appState', { keyPath: 'id' });
                        store.createIndex('timestamp', 'timestamp');
                    }
                },
            });

            console.log('✅ IndexedDB initialized successfully');
        } catch (err) {
            console.log('⚠️ IndexedDB failed. ', err);
            this.isFallback = true;
        }

        return this.db || null;
    }

    // Initializes the application state. (Restores UI state when saved data exists)
    async init(initialData = {}) {
        console.log('🏗️ Initializing Products Gallery State...');

        await this.initDB();
        const savedState = await this.loadFromDB();
        if (savedState?.photoToArt?.frames?.length > 0) {
            console.log('📂 Loaded existing state');
            const photoToArt = savedState.photoToArt;
            const frames = savedState.photoToArt.frames
            const images = savedState.images || [];
            const allImagesNull = images.every(img => img === null);

            this.persistData = true;
            this.photoToArt = savedState.photoToArt;
            this.frames = savedState.photoToArt.frames
            this.images = savedState.images;

            if (!allImagesNull) {
                this.posToIndex = savedState.posToIndex;
            } else {
                savedState.posToIndex = this.posToIndex;
            }

            this.state = savedState;
            this._restoreUIFromState(savedState);
            this.data = savedState;

        } else {
            console.log('🆕 Creating new state');
            this.persistData = false;
            this.data = this.state;
        }
        return this.data;
    }

    // ================================================================
    // PERSISTENCE
    // ================================================================

    //* Creates a safe, serializable copy of the application state , before persisting it to storage.
    sanitizeAppStateForStorage(state) {
        let clone;
        try {
            clone = typeof structuredClone === "function"
                ? structuredClone(state)
                : JSON.parse(JSON.stringify(state));
        } catch (e) {
            console.error("Error cloning app state:", e);
            return state;
        }

        clone.frames?.forEach(frame => {
            if (frame?.image?.file !== undefined) {
                delete frame.image.file;
            }
        });

        return clone;
    }

    // Persists application state to IndexedDB or localStorage.
    async saveToDB() {
        const data = this.data;
        if (!data || this.cartAddSucceeded) return false;

        // push a copy into the queue
        let dataToSave = data;
        if (this.isFallback) dataToSave = JSON.parse(JSON.stringify(data))
        this.queue.push(dataToSave);

        if (this.isSaving) return;

        this.isSaving = true;

        while (this.queue.length > 0) {
            const now = Date.now();
            const elapsed = now - this.lastSaveTime;

            // throttle
            if (elapsed < this.minInterval) {
                await new Promise(r => setTimeout(r, this.minInterval - elapsed));
            }

            if (!this.queue.length || this.cartAddSucceeded) break;
            const currentData = this.queue.shift();

            try {
                currentData.timestamp = Date.now();
                const safeData = this.sanitizeAppStateForStorage(currentData);
                const productKey = window.ProductId || 'default';

                if (this.isFallback) {
                    localStorage.setItem(`pgAppState_${productKey}`, JSON.stringify(safeData));
                } else {
                    const tx = this.db.transaction(['appState'], 'readwrite');
                    await tx.objectStore('appState').put({ id: productKey, ...safeData });
                    await tx.done;
                }
            } catch (error) {
                console.error('❌ Failed to save state:', error);
            }
        }

        this.isSaving = false;
        return true;
    }

    // Clears persisted application state from storage and resets in-memory state tracking.
    async clearSavedState() {
        this.data = null;
        this.queue = [];
        this.lastSaveTime = 0;

        try {
            const productKey = window.ProductId || 'default';

            if (this.isFallback) {
                localStorage.removeItem(`pgAppState_${productKey}`);
            } else {
                const tx = this.db.transaction(['appState'], 'readwrite');
                await tx.objectStore('appState').delete(productKey);
                await tx.done;
            }

            console.log(`🧹 Cleared saved state for key: ${productKey}`);
        } catch (error) {
            console.error('❌ Failed to clear saved state:', error);
        }

    }

    // Start uploads for frames that need uploading
    async startUploadsForFrames(frameIds = null) {
        if (!frameIds) {
            // Get all frames that need uploading
            const framesNeedingUpload = this.getFramesNeedingUpload();
            frameIds = framesNeedingUpload.map(f => f.id);
        }

        if (frameIds.length === 0) {
            console.log('ℹ️ No frames need uploading');
            return;
        }

        console.log(`📋 Adding ${frameIds.length} frames to upload queue`);

        // Add frames to upload queue
        frameIds.forEach(async frameId => {
            const frame = this.frames.find(f => f?.id === frameId);
            const i = this.frames.findIndex(f => f?.id === frameId);
            const filestackUrl = await this.uploadFrameToFilestack(frame);
            let orgI = this.images.findIndex(img => img?.editPos == frame?.editPos);
            if (orgI == -1) orgI = i;
            this.images[orgI] = {
                ...this.images[orgI],
                previewURL: filestackUrl,
                filestackUrl,
                status: this.IMAGE_STATUS.UPLOADED,
                file: null,
            };

            this.frames[i] = {
                ...this.frames[i],
                image: {
                    ...this.frames[i].image,
                    filestackUrl,
                    previewURL: filestackUrl,
                    status: this.IMAGE_STATUS.UPLOADED
                }
            };

            this.photoToArt.frames[i] = {
                ...this.photoToArt.frames[i],
                image: {
                    ...this.photoToArt.frames[i].image,
                    filestackUrl,
                    previewURL: filestackUrl,
                    status: this.IMAGE_STATUS.UPLOADED
                }
            };

            this.updateGState({
                images: this.images,
                photoToArt: this.photoToArt,
                Frames: this.frames
            });
        });

        this.checkAllImagesUploaded();
    }

    // Resume uploads on page load
    async resumeUploads() {
        // Check for frames that need uploading
        const framesNeedingUpload = this.getFramesNeedingUpload();

        if (framesNeedingUpload.length > 0) {
            console.log(`📋 Found ${framesNeedingUpload.length} frames needing upload`);
            await this.startUploadsForFrames();
        } else {
            console.log('✅ No uploads needed to resume');
        }
    }

    // Get frames that need to be uploaded (have file but no filestackUrl)
    getFramesNeedingUpload() {
        if (!this.data?.Frames) return [];

        return this.data.Frames.filter(frame =>
            frame && (frame?.image?.file || frame?.image?.previewURL) &&
            !frame?.image?.filestackUrl &&
            frame?.image?.status !== this.IMAGE_STATUS.UPLOADED
        );
    }

    // Loads persisted application state from storage.
    async loadFromDB() {

        const productKey = window.ProductId || 'default';

        try {
            let savedState = null;

            if (this.isFallback) {
                const raw = localStorage.getItem(`pgAppState_${productKey}`);
                savedState = raw ? JSON.parse(raw) : null;
                console.log(`📂 Loaded state from localStorage for product ${productKey}`);
            } else {
                const tx = this.db.transaction(['appState'], 'readonly');
                savedState = await tx.objectStore('appState').get(productKey);
                console.log(`📂 Loaded state from IndexedDB for product ${productKey}`);
            }

            if (savedState) {
                // this.clearError('database');
            }

            // Resume uploads if there are frames that need uploading
            setTimeout(() => {
                if (Array.isArray(savedState?.images) &&
                    savedState.images.some(i => i !== null) && typeof this.resumeUploads === 'function') {
                    this.resumeUploads();
                }
            }, 2000);
            return savedState;
        } catch (error) {
            console.error('❌ Failed to load state:', error);
            // this.setError('database', `Load failed: ${error.message}`);
            throw error;
        }
    }

    // Clears persisted application state for a specific product.
    async clearDB(productId = window.ProductId || 'default') {
        if (this.isFallback) {
            localStorage.removeItem(`pgAppState_${productId}`);
            console.log(`🗑️ Cleared state from localStorage for product ${productId}`);
            return true;
        }

        const tx = this.db.transaction(['appState'], 'readwrite');
        await tx.objectStore('appState').delete(productId);
        await tx.complete;
        console.log(`🗑️ Cleared state from IndexedDB for product ${productId}`);
        return true;
    }

    // Create the global state object
    createGlobalState() {
        return {
            // Images and editing
            images: null,
            posToIndex: null,
            scaled: null,
            full: null,
            // UI state
            photoLabels: null,
            dType: window.innerWidth <= 800 ? 'M' : window.innerWidth <= 868 ? 'M' : 'D',
        };
    }

    // Resolves variant data from the product map using a normalized variant name.
    getVariantData(variantName) {
        console.log(variantName, "---getVariantData---")
        let key =
            variantName // "Small / Oak"   
                .replace(/ /g, "_")  // → "Small_/_Oak"
                .replace(/\//g, "")  // → "Small__Oak"
                .replace(/\(/g, "_")
                .replace(/\)/g, "")
                .replace(/_+/g, "_"); // → collapse "_+" → "Small_Oak

                return prdctmap[key] || null;
    }

    // Generate random ID
    makeId(length = 8) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({ length }, () => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
    }

    // Generate frame ID
    async generateFrameId() {
        const makeId = this?.makeId || (() => Math.random().toString(36).substr(2, 8));
        return `frame_${Date.now()}_${makeId(6)}`;
    }

    // Generate product ID
    generatePhotoToArtId() {
        const makeId = this?.makeId || (() => Math.random().toString(36).substr(2, 8));
        return `photo_art_${Date.now()}_${makeId(6)}`;
    }

    // Renders available frame options inside the frame swiper.
    renderFrameOptions(containerSelector = ".pta_vp__frame-box .pta_vp__content") {
        const wrapper = document.querySelector(containerSelector + ' .swiper-wrapper');
        if (!wrapper) return;

        wrapper.innerHTML = "";

        const sFrame =   frameStyleMap.has(this.photoToArt.frame) ? this.photoToArt.frame : frameStyleMap.keys().next().value;

        const s = frameStyleMap.get(sFrame);

        Array.from(frameStyleMap).forEach(([frame, frameObj]) => {
            const isSelected = frame === sFrame;
            const slideHTML = `
                <div class="swiper-slide" data-style="${frame}">
                    <div
                    class="pta_vp__frame-box__item pta_vp__item ${isSelected ? 'selected' : ''}"
                    data-value="${frame}"
                    >
                    <div class="pta_vp__item-box">
                        <div class="pta_vp__item-shape-box">
                        <img src="${frameObj?.frameThumbnail || 'https://cdn.shopify.com/s/files/1/0879/7264/3112/files/oak.png?v=1756906104'}" alt="${frame}" class="pta_vp__item-shape-img" />
                        </div>
                        <p class="f12">${frame}</p>
                    </div>
                    </div>
                </div>
            `;
            wrapper.insertAdjacentHTML("beforeend", slideHTML);
        })

        if(this.S$Q("#frameArt")){
             this.S$Q("#frameArt").dataset.frame = sFrame;
             this.updatePhotoToArtState({
                frame: sFrame
             })
        };

        // if(sFrame === "Canvas Prints" || sFrame === "Framed Canvas") {
        //     this.S$Q(".pta_vp__acr-box").style.display = "none"
        // }else{
        //     this.S$Q(".pta_vp__acr-box").style.display = "block"
        // }

        this.renderStyleOptions(undefined, { skipSizeRender: true });
        this.renderSizeOptions();
    }

    // Renders style options for the currently selected frame.
    renderStyleOptions(containerSelector = ".pta_vp__style-box .pta_vp__content", { skipSizeRender = false } = {}) {
        const wrapper = document.querySelector(containerSelector + ' .swiper-wrapper');
        if (!wrapper) return;

        wrapper.innerHTML = "";

        const sFrame =   frameStyleMap.has(this.photoToArt.frame) ? this.photoToArt.frame : frameStyleMap.keys().next().value;

        const s = frameStyleMap.get(sFrame);

        if(Array.from(s.styles).length < 1){
            this.S$Q(".pta_vp__style-box").style.display = "none";
            this.S$Q("#frameArt").dataset.frameStyle = null;
             this.updatePhotoToArtState({
                style: null
             })
            return;
        }

        const titleEl = this.S$Q(".pta_vp__style-box .pta_vp__title p");
        const iconLink = titleEl.querySelector("a");

        if (sFrame.toLowerCase().includes("canvas prints")) {
            titleEl.childNodes[0].nodeValue = "Edge ";
            iconLink.setAttribute("href", "#edge-info-popup");
        } else if(sFrame.toLowerCase().includes("framed canvas")) {
            titleEl.childNodes[0].nodeValue = "Style ";
            iconLink.setAttribute("href", "#style-frame-info-popup");
        }else {
            titleEl.childNodes[0].nodeValue = "Style ";
            iconLink.setAttribute("href", "#style-info-popup");
        }

        this.S$Q(".pta_vp__style-box").style.display = "block";

        const selectedStyle = Array.from(s.styles).some(([style]) => style === this.photoToArt.style) ? this.photoToArt.style : Array.from(s.styles)[0][0]; 

        Array.from(s.styles).forEach(([style, styleObj]) => {
            const isSelected = style === selectedStyle;
            const slideHTML = `
                <div class="swiper-slide" data-style="${style}">
                    <div
                    class="pta_vp__style-box__item pta_vp__item ${isSelected ? 'selected' : ''}"
                    data-value="${style}"
                    >
                    <div class="pta_vp__item-box">
                        <div class="pta_vp__item-shape-box">
                        <img src="${styleObj?.styleThumbnail || 'https://cdn.shopify.com/s/files/1/0879/7264/3112/files/oak.png?v=1756906104'}" alt="${style}" class="pta_vp__item-shape-img" />
                        </div>
                        <p class="f12">${style}</p>
                    </div>
                    </div>
                </div>
            `;
            wrapper.insertAdjacentHTML("beforeend", slideHTML);
        })

        if(szsp){
            szsp.destroy(true, true);
            szsp = null;
        }

        szsp = new Swiper('.swiper3', {
            slidesPerView: 'auto',
            spaceBetween: 4,
            watchOverflow: true,

            navigation: {
                nextEl: '.swiper3-button-next',
                prevEl: '.swiper3-button-prev',
            }
        });

        const selectedSlide = document.querySelector('.swiper3 .pta_vp__item.selected');

        const selectedIndex = selectedSlide ? [...selectedSlide.closest('.swiper-wrapper').children].indexOf(selectedSlide.closest('.swiper-slide')) : 0;
            
        if (selectedIndex > -1) {
            szsp.slideTo(selectedIndex - 1, 0, false);
        }
        
        if(this.S$Q("#frameArt")){
             this.S$Q("#frameArt").dataset.frameStyle = selectedStyle;
             this.S$Q("#frameArt").dataset.frame = sFrame;
             this.updatePhotoToArtState({
                frame: sFrame,
                style: selectedStyle
             })
        } else{
            this.updatePhotoToArtState({
                frame: sFrame,
                style: selectedStyle
             })
        };
        // this.buildFramesSummary();
        if (!skipSizeRender) {
            this.renderSizeOptions();
        }
    }

    formatPrice(priceInCents) {
        const price = priceInCents / 100;
        
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
            .format(price)
            .replace(/\.00$/, ''); 
    }

    normalizeSize = (size) => {
        if (!size) return size;

        const [a, b] = size.split(/[x*]/).map(Number);
        if (!a || !b) return size;

        const min = Math.min(a, b);
        const max = Math.max(a, b);

        return `${min}x${max}`;
    };

    getBestFallbackSize = (sizeEntries, targetSize) => {
        if (!targetSize || !sizeEntries.length) {
            return sizeEntries[0].label;
        }

        const [tw, th] = targetSize.split("x").map(Number);
        const targetOrientation = tw >= th ? "landscape" : "portrait";

        let bestSize = sizeEntries[0].label;
        let bestScore = Infinity;

        for (const { width: w, height: h, label: size } of sizeEntries) {
            const orientation = w >= h ? "landscape" : "portrait";

            let score = Math.abs(w - tw) + Math.abs(h - th);

            if (orientation !== targetOrientation) {
                score += 50;
            }

            if (score < bestScore) {
                bestScore = score;
                bestSize = size;
            }
        }

        return bestSize;
    };

    getSizeOrientations(size) {
        if (!size) return [];

        const [w, h] = size.split(/[xX*]/).map(Number);
        if (!w || !h) return [];

        if (w === h) {
            return [{ width: w, height: h, label: `${w}x${h}` }];
        }

        return [
            { width: w, height: h, label: `${w}x${h}` },
            { width: h, height: w, label: `${h}x${w}` }
        ];
    };

    renderSizeOptions(containerSelector = ".pta_vp__size-box .pta_vp__content") {
        const wrapper = document.querySelector(
            containerSelector + " .swiper-wrapper"
        );
        if (!wrapper) return;

        const selectedFrame = frameStyleMap.has(this.photoToArt.frame)
            ? this.photoToArt.frame
            : frameStyleMap.keys().next().value;

        const frameEntry = frameStyleMap.get(selectedFrame);
        if (!frameEntry) return;

        // NEW: get selected style
        const selectedStyle = frameEntry.styles.has(this.photoToArt.style)
            ? this.photoToArt.style
            : frameEntry.styles.keys().next().value;

        const styleEntry = frameEntry.styles.get(selectedStyle);

        if (!styleEntry || !styleEntry.sizes || styleEntry.sizes.size === 0) return;

        const sizeMap = new Map();

        styleEntry.sizes.forEach((data, size) => {
            this.getSizeOrientations(size).forEach(ori => {
                if (!sizeMap.has(ori.label)) {
                    sizeMap.set(ori.label, {
                        ...ori,
                        price: data.price,
                        variantId: data.variantId
                    });
                }
            });
        });

        const sizeEntries = Array.from(sizeMap.values());

        wrapper.innerHTML = "";

        const selectedSize = sizeEntries.some(s => s.label === this.photoToArt.size)
        ? this.photoToArt.size
        : this.getBestFallbackSize(sizeEntries, this.photoToArt.size);
        
        sizeEntries.forEach(sizeObj => {
            const { label: size, price } = sizeObj;

            const [w, h] = size.split(/[xX]/).map(Number);

            let fwidth, fheight;
            if (w > h) {
                fwidth = 30;
                fheight = (h / w) * 30;
            } else if (w < h) {
                fheight = 30;
                fwidth = (w / h) * 30;
            } else {
                fwidth = fheight = 30;
            }

            const isSelected = size === selectedSize;

            const slideHTML = `
                <div class="swiper-slide">
                    <div class="pta_vp__size-box__item pta_vp__item ${isSelected ? "selected" : ""}"
                    data-value="${size}">
                    
                    <div class="pta_vp__item-box">
                        <div class="pta_vp__item-shape-box">
                        <div class="pta_vp__item-shape"
                            style="width:${fwidth}px; height:${fheight}px;">
                        </div>
                        </div>

                        <label class="f12 w6">${size}</label>
                        <label class="f10">${this.formatPrice(price)} Each</label>
                    </div>
                    </div>
                </div>
            `;

            wrapper.insertAdjacentHTML("beforeend", slideHTML);
        });

        if (stsp) {
            stsp.destroy(true, true);
            stsp = null;
        }

        var stsp = new Swiper('.swiper4', {
            slidesPerView: 'auto',
            spaceBetween: 4,
            watchOverflow: true,

            navigation: {
                nextEl: '.swiper4-button-next',
                prevEl: '.swiper4-button-prev',
            }
        });

        const selectedSlide = document.querySelector('.swiper4 .pta_vp__item.selected');

        const selectedIndex = selectedSlide ? [...selectedSlide.closest('.swiper-wrapper').children].indexOf(selectedSlide.closest('.swiper-slide')) : 0;

        if (selectedIndex > -1) {
            stsp.slideTo(selectedIndex - 1, 0, false);
        }

        const [selW, selH] = selectedSize.split(/[xX]/).map(Number);

        if (this.S$Q("#frameArt")) {
            this.S$Q("#frameArt").dataset.frameSize = selectedSize;
            this.S$Q("#frameArt").dataset.frame = selectedFrame;
            this.S$Q("#frameArt").dataset.frameStyle = selectedStyle;

            this.updatePhotoToArtState({
                frame: selectedFrame,
                style: selectedStyle,
                size: selectedSize,
                width: selW,
                height: selH
            });
        } else {
            this.updatePhotoToArtState({
                frame: selectedFrame,
                style: selectedStyle,
                size: selectedSize,
                width: selW,
                height: selH
            });
        }
        this.buildFramesSummary();
    }

    // Updates a frame’s nested properties using dot notation 
    updateFrameState(frameId, pathOrUpdates, valueIfSingle) {
        const frameIndex = this.frames.findIndex(f => f?.id === frameId);
        if (frameIndex === -1) return;

        let updatedFrame = structuredClone(this.frames[frameIndex]);

        // If updating multiple paths at once (object form)
        if (typeof pathOrUpdates === "object" && !Array.isArray(pathOrUpdates)) {
            Object.entries(pathOrUpdates).forEach(([path, value]) => {
                updatedFrame = this.deepUpdate(updatedFrame, path, value);
            });
        }
        // If updating a single path
        else if (typeof pathOrUpdates === "string") {
            updatedFrame = this.deepUpdate(updatedFrame, pathOrUpdates, valueIfSingle);
        }

        this.frames[frameIndex] = updatedFrame;
        this.updateGState({ Frames: this.frames }, false);
    }

    //  Immutably modifies a nested object path (e.g., styles.width) without mutation.
    deepUpdate(obj, path, value) {
        const keys = path.split(".");
        const lastKey = keys.pop();
        const newObj = structuredClone(obj);
        let ref = newObj;
        keys.forEach(k => {
            ref[k] = { ...ref[k] };
            ref = ref[k];
        });
        ref[lastKey] = value;
        return newObj;
    }

    // Validates whether a frame with the given ID exists
    validateFrame(frameId) {
        return this.photoToArt?.frames?.some(f => f?.id === frameId);
    }

    //  Creates a debounced version of a function.
    debounce(func, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

    // Creates a throttled function using requestAnimationFrame.
    throttleWithRaf(fn) {
        let scheduled = false;
        let lastArgs, lastContext;

        return function (...args) {
            lastArgs = args;
            lastContext = this;

            if (!scheduled) {
                scheduled = true;
                requestAnimationFrame(() => {
                    scheduled = false;
                    fn.apply(lastContext, lastArgs);
                });
            }
        };
    }

    /**
         * updatePhotoToArtState
         *
         * Handles updates at 3 levels:
         *
         * 1️⃣ Single-frame update (unchanged)
         *    Example:
         *    this.updatePhotoToArtState({ "cssStyles.left": 100 }, null, "frame123");
         *
         * 2️⃣ Multi-frame batch update
         *    Example:
         *    this.updatePhotoToArtState({
         *      frame123: { "cssStyles.left": 10, "cssStyles.top": 20 },
         *      frame456: { "cssStyles.left": 100, "cssStyles.top": 200 }
         *    });
         *
         * 3️⃣ caption-level update (unchanged)
         *    Example:
         *    this.updatePhotoToArtState({ "title": "My caption" });
         *
         * Notes:
         * - Internally clones `this.caption` to keep state immutable.
         * - Updates frame.modified or caption.modified timestamp.
         * - Calls saveToDB() and updateGState() after applying changes.
     */
    updatePhotoToArtState(pathOrUpdates, valueIfSingle, frameId = null) {
        const timestamp = Date.now();
        let updatedcaption = structuredClone(this.photoToArt);

        // === 1. Multi-frame batch update ===
        // Example: { frameId1: { "cssStyles.left": 10 }, frameId2: {...} }
        if (
            typeof pathOrUpdates === "object" &&
            !Array.isArray(pathOrUpdates) &&
            !frameId &&
            Object.values(pathOrUpdates).every(v => typeof v === "object")
        ) {
            Object.entries(pathOrUpdates).forEach(([fid, updates]) => {
                const frameIndex = updatedcaption.frames.findIndex(f => f?.id === fid);
                if (frameIndex === -1) return;

                let updatedFrame = structuredClone(updatedcaption.frames[frameIndex]);
                Object.entries(updates).forEach(([path, value]) => {
                    updatedFrame = this.deepUpdate(updatedFrame, path, value);
                });
                updatedFrame.modified = timestamp;
                updatedcaption.frames[frameIndex] = updatedFrame;

                // Also keep per-frame state in sync
                this.updateFrameState(fid, { ...updatedFrame });
            });
        }

        // === 2. Single-frame update (original branch) ===
        else if (frameId) {
            if (!this.validateFrame(frameId)) {
                console.error(`Frame ${frameId} not found`);
                return;
            }
            const frameIndex = updatedcaption.frames.findIndex(f => f?.id === frameId);
            if (frameIndex === -1) return;

            let updatedFrame = structuredClone(updatedcaption.frames[frameIndex]);

            if (typeof pathOrUpdates === "object" && !Array.isArray(pathOrUpdates)) {
                Object.entries(pathOrUpdates).forEach(([path, value]) => {
                    updatedFrame = this.deepUpdate(updatedFrame, path, value);
                });
            } else if (typeof pathOrUpdates === "string") {
                updatedFrame = this.deepUpdate(updatedFrame, pathOrUpdates, valueIfSingle);
            }

            updatedFrame.modified = timestamp;
            updatedcaption.frames[frameIndex] = updatedFrame;
            this.updateFrameState(frameId, { ...updatedFrame });
        }

        // === 3. caption-level update (unchanged) ===
        else {
            if (typeof pathOrUpdates === "object" && !Array.isArray(pathOrUpdates)) {
                Object.entries(pathOrUpdates).forEach(([path, value]) => {
                    updatedcaption = this.deepUpdate(updatedcaption, path, value);
                });
            } else if (typeof pathOrUpdates === "string") {
                updatedcaption = this.deepUpdate(updatedcaption, pathOrUpdates, valueIfSingle);
            }
        }

        updatedcaption.modified = timestamp;
        this.photoToArt = updatedcaption;

        // Attach to state
        this.data = this.data || {};
        // this.saveToDB();
        this.updateGState({ photoToArt: updatedcaption });
    }

    // Generates a new caption with defaults (ID, style, timestamps).
    createPhotoToArtObject({
        photoToArtId,
        title = "",
        width,
        height,
        style = "Oak",
        frame="Framed Prints",
        price = null,
        size = null,
        frames = [],
        fullImg = null,
        s3Img = null,
        variantID = null,
        acrylic = true,
        text = {
            heading: "",
            hColor: "#000000",
            description: "",
            dColor: "#999999",
        }
    } = {}) {
        const timestamp = Date.now();

        return {
            id: photoToArtId,
            title,
            width,
            height,
            style,
            frame,
            price,
            size,
            fullImg,
            s3Img,
            variantID,
            created: timestamp,
            modified: timestamp,
            frames,
            acrylic,
            text: text
        };
    }

    // Creates a frame object with preset image/styling defaults (size, crop, position).
    createFrameObject({
        frameId,
        sizeVariant = "17x25",
        size = "25x17",
        width = null,
        height = null,
        previewURL = null,
        filestackUrl = null,
        status = "pending",
        crop = "",
        visableCrop = "",
        scale = "min",
        minScale = "false",
        naturalWidth = null,
        naturalHeight = null,
        cssStyles = {
            height: null,
            width: null,
            x: 0,
            y: 0,
        },
        imgStyles = {
            left: 0,
            top: 0,
            scale: 1,
            width: 0,
            height: 0,
            rotation: 0
        },
        variantID = null,
        originalPos = 0,
        editPos = 0,
        file = null
    } = {}) {

        const timestamp = Date.now();

        return {
            id: frameId,
            originalPos,
            editPos,
            size: {
                variant: sizeVariant,
                size,
                width,
                height
            },
            image: {
                previewURL,
                filestackUrl,
                file,
                status,
                crop,
                visableCrop,
                scale,
                imgStyles,
                minScale,
                naturalWidth,
                naturalHeight,
                modified: timestamp,
            },
            cssStyles,
            created: timestamp,
            modified: timestamp,
            variantID,
            positionIndex: editPos + 1,
        };
    }

    // DOM Helper Methods
    S$Q = document.querySelector.bind(document);
    S$$ = document.querySelectorAll.bind(document);
    S$G = document.getElementById.bind(document);

    // Convert inches to pixels using the configured DPI.
    toPx(inch) {
        return inch * this.dpi;
    }

    // Returns the default Photo Upload (PU) state object.
    getDefaultPu() {
        return {
            ceF: null, ceB: null, ceI: null,
            cuF: null, cuB: null, cuI: null,
            ceHeight: null, ceWidth: null,
            cuHeight: null, cuWidth: null,
            ceLeft: null, ceTop: null,
            cuLeft: null, cuTop: null,
            ceScale: null, cuScale: null,
            ceBW: null, cuBW: null,
            ceSize: null, cuSize: null,
            ceSizeVariant: null, cuSizeVariant: null,
            ceStyle: null, cuStyle: null,
            ceBorder: null, cuBorder: null,
            ceAcrylic: null, cuAcrylic: null,
            ceNW: 0, ceNH: 0,
            isOpen: true, SoPchanged: false,
            SoRchanged: false, SoCchanged: false,
            posrotation: "h", rotation: 0,
            zmSlider: null, image: null
        };
    }

    // Update method for the global state
    updateGState(updates, save = true) {
        const deepMerge = (target, source) => {
            for (const key in source) {
                if (source[key] instanceof Object && !Array.isArray(source[key])) {
                    if (!target[key]) target[key] = {};
                    deepMerge(target[key], source[key]);
                } else {
                    target[key] = source[key];
                }
            }
            return target;
        };

        deepMerge(this.state, updates);
        // Attach to state
        this.data = this.data || {};
        this.data = this.state;
        if (save) {
            this.saveToDB();
        }
        return this.state;
    }

    // Popup State
    updatePopupState(updates = {}) {
        Object.assign(this.pu, updates);
    }

    // DOM Element Initialization
    initElements() {
        // Main elements
        this.photoSlotsContainer = this.S$G('frameArt');
        this.photoList = document.querySelector('.pta_vp__photo-box .pta_photo_content');
        this.sizeOptions = this.S$G('size-options');
        this.remainingPhotos = this.S$G('remaining-photos');

        // Edit modal elements
        this.rotateLeft = this.S$G('rotate-left');
        this.rotateRight = this.S$G('rotate-right');
        this.blackWhite = this.S$G('black-white');
        this.fileInputs = [];
    }

    // Restore UI From Saved State
    _restoreUIFromState(state) {

        // Restore dropdown selections
      S$Q('.pta_vp__size-box')?.setAttribute('data-selected-size', state.photoToArt.size);
      S$Q('.pta_vp__style-box')?.setAttribute('data-selected-style', state.photoToArt.style);
      S$Q('.pta_vp__frame-box')?.setAttribute('data-selected-frame', state.photoToArt.frame);

      // Update selected items
      const updateSelected = (container, value) => {
        container?.querySelector('.selected')?.classList.remove('selected');
        container?.querySelector(`[data-value="${value}"]`)?.classList.add('selected');
      };

      updateSelected(S$Q('.pta_vp__size-box'), state.photoToArt.size);
      updateSelected(S$Q('.pta_vp__style-box'), state.photoToArt.style);
      updateSelected(S$Q('.pta_vp__frame-box'), state.photoToArt.frame);

    if( S$Q(".text-content .heading")){
        S$Q(".text-content .heading").value  = state?.photoToArt?.text?.heading;
        const counterSpan = S$Q(".text-content.head .char-counter");
        if (counterSpan) this.updateCounter(counterSpan, state?.photoToArt?.text?.heading);
    }

    if(S$Q(".color-dot.hColor .item")) S$Q(".color-dot.hColor .item").style.backgroundColor = state?.photoToArt?.text?.hColor;
    if(S$Q(".text-content .desc")){
        S$Q(".text-content .desc").value =  state?.photoToArt?.text?.description;
        const counterSpan = S$Q(".text-content.des .char-counter");
        if (counterSpan) this.updateCounter(counterSpan, state?.photoToArt?.text?.description);
    }
    if(S$Q(".color-dot.dColor .item")) S$Q(".color-dot.dColor .item").style.backgroundColor =  state?.photoToArt?.text?.dColor;


      // Restore container attributes
    //   const imgContainer = S$Q('.img-uptile-container');
    //   if (imgContainer) {
    //     if (state.uploaderCss) imgContainer.setAttribute('style', state.uploaderCss);
    //     imgContainer.setAttribute('data-width-in-inches', state.selectedSize.width);
    //     imgContainer.setAttribute('data-height-in-inches', state.selectedSize.height);
    //     imgContainer.setAttribute('data-frame-style', state.selectedStyle);
    //   }

      const acrylicCheckbox = S$G('vpacr');
      if (acrylicCheckbox) acrylicCheckbox.checked = state.photoToArt.acrylic;
    }
    
    // Global Event Listeners
    setupEventListenersG() {
        window.addEventListener('pageshow', (event) => {
            if (event.persisted && this.cartAddSucceeded) {
                window.location.reload();
            }
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest(".color-dot")) {
                document.querySelectorAll("#colorPopup").forEach(p => p.style.display = "none");
            }
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            var actionElement = e.target.hasAttribute('data-action') ? e.target : e.target.closest('[data-action]');
            if (!actionElement) return;
            var action = actionElement.getAttribute('data-action');

            if (action === 'sidebar-selection') {
                const target = e.target.closest('[data-value]');
                const container = e.target.closest('[data-category]');
                if (!target || !container) return;

                const category = container.getAttribute('data-category');
                const value = target.getAttribute('data-value');

                // Disable ATC button immediately on size/style/border/acrylic clicks
                if (['size', 'style', 'border', 'frame'].includes(category)) {
                    this.S$Q('.pta_st__atc-btn')?.classList.add('disa');
                    setTimeout(() => {
                        // this.S$Q('.pta_st__atc-btn')?.classList.remove('disa');
                        this.checkAllImagesUploaded();
                    }, 1000);
                }

                if(S$$(".frameArt")?.length !== 0 && value == S$Q(".frameArt").getAttribute('data-frame-' + category)){
                    console.warn(`skipping because value (${value}) and selected ${category} is same (${S$Q(".frameArt").getAttribute('data-frame-' + category)}) for all`)
                    return;
                }
                
                // if (this.checkFC(category)) {
                this.updateSelectedValue(container, target, category, value);
                // } else {
                //     this.changeAllWarningShow(container, target, category, value);
                // }
            } else if (action === 'popup-menu') {
                return;
                const target = e.target.closest('[data-value]');
                const value = target.getAttribute('data-value');
                if (value == "delete") {
                    var epopup = this.S$Q('.pta_epu');
                    var eframe = this.S$Q('.pta_epu-body .frame');
                    var ftu = this.S$Q('.img-thumbs .frame[data-frame-index="' + epopup.dataset.editIndex + '"]').parentElement;
                    var frameId = ftu.querySelector('.framefh')?.dataset.frameId;
                    ftu.remove();
                    epopup.style.display = "none";
                    eframe.remove();
                    Pg.State?.removeFrame(frameId);
                    Pg.Frames.setFID();
                    var frames = this.S$$('.frame');
                    Pg.Frames.updateFrameSizes("size");
                    Pg.Frames.handleSwiper(frames);
                    Pg.Cart?.buildFramesSummary?.();
                    Pg.Popup.current.isOpen = false;
                    if (this.S$$('.framefh').length == 0) {
                        this.S$Q('.pta_st__atc-btn').classList.add('disa');
                    }
                } else {
                    var p = "pta_epu-f" + value;
                    actionElement.parentElement.parentElement.parentElement.querySelector('.pta_epu-fcurrent').classList.remove('pta_epu-fcurrent');
                    this.S$Q('.pta_epu-footer').dataset.active = p;
                    actionElement.parentElement.parentElement.parentElement.querySelector('.' + p).classList.add('pta_epu-fcurrent');
                    if (p === "pta_epu-facrylic") {
                        const frame = actionElement.parentElement.parentElement.parentElement.querySelector('.' + p)?.closest('.pta_epu-box')?.querySelector('.frame.framefh');
                        this.S$G('epuacr').checked = frame?.getAttribute('data-frame-acrylic') === "true";
                    }
                };
            } else if (action === 'popup-selection') {
                const target = e.target.closest('[data-value]');
                const container = e.target.closest('[data-category]');
                if (!target || !container) return;

                const category = container.getAttribute('data-category');
                const value = target.getAttribute('data-value');
                this.updateSelectedValue(container, target, category, value);
            } else if (action === 'popup-selection-done') {
                this.S$Q('.pta_epu-fcurrent').classList.remove('pta_epu-fcurrent');
                this.S$Q('.pta_epu-fmain').classList.add('pta_epu-fcurrent');
                this.S$Q('.pta_epu-footer').dataset.active = "pta_epu-fmain";
                this.loadImageForEditing();
            } else if (action === 'popup-done') {
                this.endSEdit();
            } else if (action === 'edit-item') {
                this.S$Q('.pta_eupu').classList.remove("pta_eupu-open");
                this.S$Q(
                    `foreignObject[data-index="${this.uploadIndex}"] .pta_eb`
                ).click();
            } else if (action === 'change-item') {
                this.S$Q('.pta_eupu').classList.remove("pta_eupu-open");
                this.S$Q('.pta_upu')?.classList.add(`pta_upu-open`);
            } else if (action === 'popup-cancel') {
                this.S$Q('.pta_epu-fcurrent').classList.remove('pta_epu-fcurrent');
                this.S$Q('.pta_epu-fmain').classList.add('pta_epu-fcurrent');
                this.S$Q('.pta_epu-footer').dataset.active = "pta_epu-fmain";
                // this.S$Q('.pta_epu').style.display = "none";
                // this.S$Q('.pta_epu-body .frameArt').remove();
                this.removePopupListeners();
                this.pu.isOpen = false;
                this.closePopupAnimation();
            }
        });

        // upload input event listner
        this.S$Q('.img-upload.hidden')?.addEventListener('change', (e) => {this.handleFileSelect(0, e)});

        this.S$Q('#vpacr')?.addEventListener('change', (e) => {
          // Disable ATC button immediately on acrylic change
          S$Q('.pta_st__atc-btn')?.classList.add('disa');
           const checkbox = e.target;
            if (!checkbox) {
                console.error("❌ Invalid checkbox element");
                return false;
            }

            const isChecked = checkbox.checked;
            this.updatePhotoToArtState({acrylic: isChecked})
            this.checkAllImagesUploaded();
            this.buildFramesSummary();
        });

        this.S$Q('#tbts')?.addEventListener('change', (e) => {
           const checkbox = e.target;
            if (!checkbox) {
                console.error("❌ Invalid checkbox element");
                return false;
            }

            const isChecked = checkbox.checked;
            if(isChecked){
                this.S$Q('.pta_vp_text_container').style.display = "block";
            }else{
                this.S$Q('.pta_vp_text_container').style.display = "none";
            }
        });

        // Upload popup listeners
        this.S$Q('.pta_upu')?.addEventListener('click', function (event) {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            event.currentTarget.classList.remove("pta_upu-open");
        });

        this.S$Q(".pta_fub__container")?.addEventListener('click', function () {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            document.querySelector('.pta_upu')?.classList.add("pta_upu-open");
        });

        this.S$Q(".pta_upu-option.upload-img")?.addEventListener('click', function () {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.fileInputs[this.uploadIndex].click();
        }.bind(this));

        this.S$Q(".download-caption")?.addEventListener('click', function (e) {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.downloadSVG(true);
        }.bind(this));

        this.S$Q(".download-caption-vizual")?.addEventListener('click', function () {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.downloadSVG(false);
        }.bind(this));

        this.S$Q(".clear-storage")?.addEventListener('click', function () {
            this.clearSavedState();
            setTimeout(() => {
                window.location.reload()
            }, 100);
        }.bind(this));

        // Delivery info listeners
        this.S$$('.pta_sbmd__view_del').forEach(el => {
          el.addEventListener('click', () => {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.S$Q('.pta_delivery_info').classList.add('pta_delivery_info-open');
            if (this.dType === "D") this.S$G("background-overlay").style.display = "block";
          });
        });

        this.S$$('.pta_delinfo-close').forEach(el => {
          el.addEventListener('click', () => {
            if (this.addToCartInProcess) {
                console.warn("add to cart is in process");
                return;
            }
            this.S$Q('.pta_delivery_info').classList.remove('pta_delivery_info-open');
            this.dType === "D" ? this.S$G("background-overlay").style.display = "none" : this.S$Q('.pta_sbmd').classList.remove('pta_sbmd-open'), this.S$G('global-overlay').classList.remove('go-active');
          });
        });

        this.S$$('.pta_delinfo-back').forEach(el => {
          el.addEventListener('click', () => {
            this.S$Q('.pta_delivery_info').classList.remove('pta_delivery_info-open');
          });
        });

        var a2cbtn = this.S$Q('.pta_st__atc-btn');
        if (a2cbtn) {
            a2cbtn.addEventListener('click', this.performAddToCart.bind(this));
        }
        this.setupFilestackUploaclanels();

        this.S$Q('.pta_eupu-cancel').addEventListener("click", () => { this.S$Q('.pta_eupu').classList.remove("pta_eupu-open") });

        const MAX_LEN = 28;
        
        // Heading listener
        this.S$Q(".text-box .text-content .heading")?.addEventListener("input", function (e) {
            let val = e.target.value;

            if (val.length > MAX_LEN) {
                val = val.slice(0, MAX_LEN);
                e.target.value = val;
            }

            const svgHeading = document.querySelector("svg div h1");
            if (svgHeading) svgHeading.innerText = val;

            const counterSpan = e.target.closest(".text-content").querySelector(".char-counter");
            if (counterSpan) this.updateCounter(counterSpan, val);

            this.updatePhotoToArtState("text", {
                ...this.state.photoToArt.text,
                heading: val
            });

        }.bind(this));


        // Description listener
        this.S$Q(".text-box .text-content .desc")?.addEventListener("input", function (e) {
            let val = e.target.value;

            if (val.length > MAX_LEN) {
                val = val.slice(0, MAX_LEN);
                e.target.value = val;
            }

            const svgDesc = document.querySelector("svg div p");
            if (svgDesc) svgDesc.innerText = val;

            const counterSpan = e.target.closest(".text-content").querySelector(".char-counter");
            if (counterSpan) this.updateCounter(counterSpan, val);

            this.updatePhotoToArtState("text", {
                ...this.state.photoToArt.text,
                description: val
            });

        }.bind(this));

        const input = document.querySelectorAll(".text-box .text-content input");

        input.forEach(i => (
            i.addEventListener("keydown", function (e) {
                const val = this.value;
                if (e.key === "Backspace" || e.key === "Delete") return;
                if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Tab"].includes(e.key)) return;

                const selStart = this.selectionStart;
                const selEnd = this.selectionEnd;
                const isReplacing = selEnd > selStart;
                if (isReplacing) return;

                if (val.length >= MAX_LEN && selStart !== val.length) {
                    e.preventDefault();
                    return;
                }

                if (val.length >= MAX_LEN) {
                    e.preventDefault();
                }
            })
        ));

        let currentColorTarget = null;
        let currentType = null;
        document.querySelectorAll(".color-dot").forEach(dot => {
            const popup = dot.querySelector("#colorPopup");
            const hexInput = dot.querySelector(".colorHexInput");

            dot.addEventListener("click", (e) => {
                e.stopPropagation();
                document.querySelectorAll(".color-dot #colorPopup").forEach(b => b.style.display = "none")
                currentColorTarget = dot.querySelector(".item");

                const parentText = dot.closest(".text-box").querySelector("input");
                currentType = parentText.classList.contains("heading") ? "heading" : "desc";

                popup.style.top = "30px";
                popup.style.right = 0 + "px";
                const currentColor = currentColorTarget.style.backgroundColor;
                const hex = rgbToHex(currentColor);
                hexInput.value = hex.replace("#", "");

                popup.style.display = "block";
            });


            hexInput.addEventListener("input", () => {
                if (hexInput.value.length === 6) {
                    currentColorTarget.style.backgroundColor = "#" + hexInput.value;
                    updateTextColor(currentType, "#" + hexInput.value);
                }
            });
        });

        document.querySelectorAll(".color-option").forEach(btn => {
            btn.style.backgroundColor = btn.dataset.color;
            btn.addEventListener("click", () => {
                currentColorTarget.style.backgroundColor = btn.dataset.color;
                // hexInput.value = btn.dataset.color.replace("#", "");
                updateTextColor(currentType, btn.dataset.color);
            });
        });

        const updateTextColor = (type, color) => {
            const sKey = type.slice(0, 1) + "Color"
            this.updatePhotoToArtState("text", {
                ...this.state.photoToArt.text,
                [sKey]: color
            })
        }

        function rgbToHex(rgb) {
            const result = rgb.match(/\d+/g).map(x => parseInt(x).toString(16).padStart(2, '0'));
            return "#" + result.join('');
        }
    }

    // Add loading class to a specific img-box
    addLoadingClass(index) {
        const imgBox = document.querySelector(`#captionGrid foreignObject[data-index="${index}"] .img-box`);
        if (imgBox) imgBox.classList.add('cimg-loading');
        this.S$Q('.pta_st__atc-btn')?.classList.add('disa');
    }

    // Remove loading class from a specific img-box
    removeLoadingClass(index, frameId) {
        if (index === 0 || index) {
            const imgBox = document.querySelector(`.img-box`);
            if (imgBox) imgBox.classList.remove('cimg-loading');
        } else if (frameId) {
            const imgBox = document.querySelector(`.frameArt[data-frame-id="${frameId}"] .img-box`);
            if (imgBox) imgBox.classList.remove('cimg-loading');
        }
        // this.S$Q('.pta_st__atc-btn')?.classList.remove('disa');
        this.checkAllImagesUploaded();
    }

    // This function is responsible for the entire external image upload flow.
    setupFilestackUploaclanels() {
        document.querySelectorAll('.pta_upu-upanel').forEach(panel => {
            panel.addEventListener('click', (e) => {
                const client = this.fileStack;

                const fileInput = document.querySelector(
                    `#captionGrid foreignObject[data-index="${this.uploadIndex}"] .img-upload`
                );

                if (!fileInput) return;

                const allowMultiple = fileInput.multiple;
                const maxLimit = this.images.length;

                const source = e.currentTarget.classList.contains("open_fb")
                    ? ["facebook", "googlephotos"]
                    : e.currentTarget.classList.contains("open_ig")
                        ? ["facebook", "googlephotos"]
                        : ["googlephotos", "facebook"];

                const options = {
                    maxFiles: allowMultiple ? maxLimit : 1,
                    uploadInBackground: false,
                    fromSources: source,
                    onOpen: () => console.log('opened!'),
                    onUploadDone: async (res) => {
                        const files = res.filesUploaded || [];

                        // figure out slot mapping ahead of time
                        const maxUploadLength = Math.min(this.images.length, files.length);
                        const emptySlots = this.getEmptySlots();
                        for (let i = 0; i < maxUploadLength; i++) {
                            if (files.length > 1) {
                                this.addLoadingClass(emptySlots[i]);
                            } else {
                                this.addLoadingClass(this.uploadIndex);
                            }
                        }

                        for (let i = 0; i < files.length; i++) {
                            const slotIndex = (files.length > 1)
                                ? emptySlots[i]
                                : this.uploadIndex;

                            if (slotIndex === undefined) continue;

                            const f = files[i];
                            let attempt = 0;
                            let success = false;

                            while (attempt < 2 && !success) {
                                try {
                                    attempt++;

                                    const response = await client.download(f.handle);
                                    const blob = response instanceof Blob ? response : response?.data;
                                    if (!blob) throw new Error("Invalid blob from download");

                                    // ✅ Step 1: Resize before doing anything else
                                    let processedFile = blob;
                                    if (blob instanceof File || blob instanceof Blob) {
                                        try {
                                            let {contain, normal} = await this.resizeImageToMaxSize(blob, 4000);
                                            processedFile = contain || normal;
                                        } catch (err) {
                                            console.error("Image resize failed, using original file:", err);
                                            processedFile = blob;
                                        }
                                    }

                                    const timestamp = Date.now().toString(36);
                                    const randomId = this?.makeId?.(8) || Math.random().toString(36).substr(2, 8);
                                    const extension = processedFile.type.split("/")[1] || "jpg";
                                    const filename = `f_f-${new Date().getMonth() + 1}_${new Date().getFullYear()}-${timestamp}${randomId}.${extension}`;

                                    let fileToUpload = processedFile instanceof File
                                        ? processedFile
                                        : new File([processedFile], filename, { type: processedFile.type });

                                    const reuploadRes = await client.upload(fileToUpload);

                                    const dataUrl = await this.toBase64(processedFile);

                                    f.dataUrl = dataUrl;
                                    f.reuploadHandle = reuploadRes.handle;
                                    f.reuploadUrl = reuploadRes.url;

                                    success = true;

                                    this.handleFileSelect(slotIndex, { filesUploaded: [f] });

                                } catch (fileErr) {
                                    console.warn(`Upload attempt ${attempt} failed for file ${f.filename}:`, fileErr);
                                    if (attempt >= 2) {
                                        console.error("Failed after retry:", fileErr);

                                        f.dataUrl = f.dataUrl || null;
                                        f.reuploadHandle = f.reuploadHandle || null;
                                        f.reuploadUrl = f.reuploadUrl || null;

                                        this.handleFileSelect(slotIndex, { filesUploaded: [f] });
                                    }
                                }
                            }
                        }
                    },
                };
                client.picker(options).open();
            });
        });
    }

    //  Handles selection changes for size, style, and frame options.
    updateSelectedValue(container, target, category, value) {
        container.querySelector('.selected')?.classList.remove('selected');
        target.classList.add('selected');
        container.setAttribute('data-selected-value', value);
        container.setAttribute(`data-selected-${category}`, value);

        const frameSelected = this.photoToArt.frame || "Framed Prints";

        switch (category) {
            case 'size':
                const [width, height] = value.split('x');
                // this.updateAllFramesSizes(value);
                if(this.S$G("frameArt")) this.S$G("frameArt").dataset.frameSize = value;
                this.updatePhotoToArtState({ "size": value, "width": parseInt(value.split('x')[0]), "height": parseInt(value.split('x')[1]) });
                this.buildFramesSummary();
                // Pg.Frames.updateAllFramesInches(parseInt(width), parseInt(height));
                break;
            case 'style':
                // this.updateAllFramesStyles(value);
                if (frameSelected === "Canvas Prints" && value === "Maple") {
                    value = this.photoToArt.style || "Oak";
                    container.querySelector(`[data-value="Maple"]`)?.classList.remove("selected");
                    container.querySelector(`[data-value=${value}]`)?.classList.add("selected");
                    container.setAttribute("data-selected-value", value);
                }
                if(this.S$G("frameArt")) this.S$G("frameArt").dataset.frameStyle = value;
                this.updatePhotoToArtState("style", value);
                this.renderStyleOptions();
                break;
            case 'frame':
                // this.updateAllFramesStyles(value);
                if(this.S$G("frameArt")) this.S$G("frameArt").dataset.frame = value;
                this.updatePhotoToArtState("frame", value);
                const currentStyle = this.photoToArt.style;
                if (value === "Canvas Prints" && currentStyle === "Maple") {
                    // this.forceStyleChange("Oak");
                    document.querySelector(`.pta_vp__style-box [data-value="Maple"]`)?.classList.remove("selected");
                    document.querySelector(`.pta_vp__style-box [data-value="Oak"]`)?.classList.add("selected");
                    document.querySelector(".pta_vp__style-box").setAttribute("data-selected-value", "Oak");
                    if(this.S$G("frameArt")) this.S$G("frameArt").dataset.frameStyle = "Oak";
                    this.updatePhotoToArtState("style", "Oak");
                }
                this.renderFrameOptions();
                break;
            default:
                break;
        }
    }

    // Creates a photo upload or edit row for a given slot index.
    createPhotoUploadBox(i, image) {
        // Create main container
        const row = document.createElement("div");
        row.className = "photo-upload-row";
        row.dataset.index = i;
        if (!image) {
            // Right side container
            const uploadBtn = document.createElement("div");
            uploadBtn.className = "upload-btn";
            uploadBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <g clip-path="url(#clip0_326_16845)">
                    <path d="M8.87109 9.98036V2.21777" stroke="white" stroke-width="1.66341" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.9679 9.98047V14.4162H2.76953V9.98047" stroke="white" stroke-width="1.66341" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.09766 4.99012L8.87001 2.21777L11.6424 4.99012" stroke="white" stroke-width="1.66341" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_326_16845">
                    <rect width="17.743" height="17.743" fill="white"/>
                    </clipPath>
                    </defs>
                </svg>
                <span>Upload Your Photo</span>
            `;

            uploadBtn.addEventListener('click', (e) => {
                const key = Object.entries(this.posToIndex).find(([k, v]) => v === i)?.[0] || 0;
                this.uploadIndex = key;
                document.querySelector('.pta_upu')?.classList.add(`pta_upu-open`);
            });
            row.appendChild(uploadBtn);

        } else {
            // row.draggable = true;
            const wrapper = document.createElement("div");
            wrapper.className ="upload-edit-wrapper";
            const changeBtn = document.createElement("div");
            changeBtn.className = "change-btn";
            changeBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                    <g clip-path="url(#clip0_834_6601)">
                    <path d="M5.14044 11C4.42131 10.9306 3.74479 10.7438 3.12155 10.4449C2.49298 10.146 1.94964 9.75643 1.49153 9.27074C1.03341 8.78506 0.66586 8.22465 0.399516 7.58952C0.133172 6.94905 0 6.25522 0 5.49733C0 4.73945 0.138499 4.04027 0.420823 3.38379C0.703148 2.72732 1.08668 2.15623 1.57676 1.66521H0.372881V0.256186H4.07506V3.96555H2.66344V2.59922C2.27458 2.96215 1.97094 3.38913 1.74722 3.88549C1.52349 4.38185 1.41162 4.92091 1.41162 5.50267C1.41162 6.5541 1.76852 7.46676 2.48232 8.22999C3.19613 8.99854 4.08039 9.44687 5.14044 9.5803V11ZM6.92494 10.7438V7.03445H8.33656V8.40078C8.72542 8.03785 9.02906 7.60553 9.25278 7.11451C9.47651 6.61815 9.58838 6.08443 9.58838 5.50267C9.58838 4.45124 9.23148 3.53857 8.51768 2.77535C7.80387 2.00679 6.91961 1.55847 5.85956 1.42504V0C7.30847 0.144105 8.52833 0.736536 9.51913 1.77729C10.5099 2.81805 11 4.05628 11 5.50267C11 6.25522 10.8615 6.95973 10.5792 7.61621C10.2969 8.27268 9.91332 8.84377 9.42325 9.33479H10.6271V10.7492H6.92494V10.7438Z" fill="white"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_834_6601">
                    <rect width="11" height="11" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg>
                <span>Change Photo</span>
            `;
            const editBtn = document.createElement("div");
            editBtn.className = "edit-btn";
            editBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M1.00284 12.9931L2.03182 9.28116C2.07079 9.14088 2.14508 9.01307 2.24822 8.9102L9.80129 1.35713C10.2775 0.880956 11.0493 0.880956 11.5252 1.35713L12.7303 2.56224C13.2065 3.03842 13.2065 3.81022 12.7303 4.28614L5.17696 11.8392C5.07409 11.9421 4.94628 12.0166 4.806 12.0556L1.09402 13.0846C1.03843 13.0999 0.987251 13.0487 1.00284 12.9931Z" stroke="white" stroke-width="1.2" stroke-miterlimit="10"/>
                <path d="M8.64111 2.48486L11.5701 5.41387" stroke="white" stroke-width="1.2" stroke-miterlimit="10"/>
                <path d="M2.25244 8.87378L5.18145 11.8028" stroke="white" stroke-width="1.2" stroke-miterlimit="10"/>
                </svg>
                <span>Edit Photo</span>
            `;

            changeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation()
                const key = Object.entries(this.posToIndex).find(([k, v]) => v === i)?.[0];
                this.uploadIndex = key;
                document.querySelector('.pta_upu')?.classList.add(`pta_upu-open`);
            }, true);

            editBtn.addEventListener('click', () => {
                const key = Object.entries(this.posToIndex).find(([k, v]) => v === i)?.[0];
                this.editpu();
            });

            const imgWraper = document.createElement("div")
            imgWraper.className = "frameArt";
            imgWraper.id = "frameArt";
            let frame = null;
            if (!imgWraper.dataset?.frameId) {
                const currentEditPos = this.images[i]?.editPos;

                frame = this.frames.find(f => {
                    return f?.id && f?.editPos !== undefined && String(f.editPos) === String(currentEditPos);
                });

                if (frame) {
                    imgWraper.dataset.frameId = frame.id;
                }
            }
            imgWraper.dataset.frame = this.photoToArt.frame
            imgWraper.dataset.frameStyle = this.photoToArt.style;
            imgWraper.dataset.frameSize = this.photoToArt.size
            const imgBox = document.createElement("div");

            imgBox.className = "img-box";
            const img = document.createElement("img");
            img.src = image?.previewURL || "/cdn/shop/files/Vector70.png?v=1765205182&width=100";

            const parsedFramedData = this?.frames.find(f => (f && f?.id) && f?.id === imgWraper.dataset?.frameId);

            let widthPx = 100, heightPx = 100, scp = 1;
            
            img.onload = () => {
                img.dataset.scale = parsedFramedData.image.scale || "min"
                // this.updateImgPosition(index, undefined, this.persistData, resize);
                this?.renderItemFromData({
                    frame: imgWraper,
                    parsedMainFrame: {
                        frameHeight: parseFloat(parsedFramedData.cssStyles.height),
                        frameWidth: parseFloat(parsedFramedData.cssStyles.width),
                        borderWidth: parseFloat(0),
                        padding: parseFloat(0),
                        scale: parseFloat(parsedFramedData.image.imgStyles.scale),
                        rotate: parseFloat(parsedFramedData.image.imgStyles.rotation),
                        top: parseFloat(parsedFramedData.image.imgStyles.top),
                        left: parseFloat(parsedFramedData.image.imgStyles.left),
                        bW: parsedFramedData.image.imgStyles.filter
                    },
                    widthPx,
                    heightPx,
                    scaleCorrection: scp,
                    applyImgBoxTransform: true,
                    // Ra4Sc,
                });

                this.removeLoadingClass(i);
                const ceB = imgBox;
                const ceI = img;    
                const frame = imgWraper;
                let frameId = frame.dataset.frameId
                const {scale: s, rotate: r } = this.getScaleAndRotation(ceI);
                this.updatePhotoToArtState({
                    "image.imgStyles.width": parseFloat(ceB.style.width),
                    "image.imgStyles.height": parseFloat(ceB.style.height),
                    "image.imgStyles.left": parseFloat(ceI.style.left),
                    "image.imgStyles.top": parseFloat(ceI.style.top),
                    "image.imgStyles.scale": parseFloat(s),
                    "image.imgStyles.rotation": parseFloat(r),
                    "image.imgStyles.filter": ceI.style.filter,
                    "image.scale": ceI.dataset.scale,
                    "cssStyles.width": parseFloat(frame.style.width),
                    "cssStyles.height": parseFloat(frame.style.height),
                }, null, frameId)
            };
            wrapper.appendChild(editBtn);
            wrapper.appendChild(changeBtn);
            row.appendChild(wrapper)
            imgBox.appendChild(img)
            imgWraper.appendChild(imgBox)
            row.appendChild(imgWraper)
        }
        return row;
    }

    // Attaches core event listeners for the image edit popup.
    initPopupEventListeners() {
        // Modal controls
        this.S$G('rotate-left').addEventListener('click', this.boundHandlers.rotateLeft, true);
        this.S$G('rotate-right').addEventListener('click', this.boundHandlers.rotateRight, true);
        this.S$G('black-white').addEventListener('click', this.boundHandlers.blackWhite, true);
    }

    // Cleans up all popup-related event listeners and UI locks.
    removePopupListeners() {
        const eventType = this.dType === "D" ? "click" : "touchstart";
        this.boundHandlers.zoomButtonHandlers.forEach((handler, button) => {
            button.removeEventListener(eventType, handler);
        });
        this.boundHandlers.zoomButtonHandlers.clear();

        if (this?.pu && this?.pu?.zmSlider) this.pu.zmSlider.removeEventListener("input", this.boundHandlers.zoomInput);

        if (this?.pu?.ceF) {
            const ceF = this?.pu?.ceF;
            const zmSlider = this?.pu?.zmSlider;
            ceF.removeEventListener('mousedown', this.boundHandlers.onStartMouse);
            ceF.removeEventListener('touchstart', this.boundHandlers.onStartTouch);
            ceF.removeEventListener('wheel', this.boundHandlers.onWheel);
            if (zmSlider) zmSlider.removeEventListener('wheel', this.boundHandlers.onWheel);

        }

        if(this.S$$(".pafp").length > 0) this.S$$(".pafp").forEach(el => el.classList.remove("body-lock"));

        this.S$Q("body").style.removeProperty("overflow");
        this.S$G('rotate-left').removeEventListener('click', this.boundHandlers.rotateLeft, true);
        this.S$G('rotate-right').removeEventListener('click', this.boundHandlers.rotateRight, true);
        this.S$G('black-white').removeEventListener('click', this.boundHandlers.blackWhite, true);
    }

    // Main render entry point for the photo list UI.
    render(resize = false) {
        this.fileInputs = [document.querySelector(".img-upload.hidden")];
        this.renderPhotoList();
        this.checkAllImagesUploaded();
    }

    //  Renders the full list of photo upload slots.
    renderPhotoList() {
        this.photoList.innerHTML = '';
        let draggedItem = null;
        if (!this.persistData) {
            Object.keys(Array(1).fill(1)).forEach((key, i) => {
                const item = this.createPhotoItem(i);
                this.photoList.appendChild(item);
            });
        } else {
            // Use persisted order from posToIndex
            Object.keys(this.posToIndex).forEach((pos) => {
                const originalIndex = this.posToIndex[pos];
                const item = this.createPhotoItem(originalIndex);
                this.photoList.appendChild(item);
            });
        }

    }

    // Creates a single photo upload item for a given slot index.
    createPhotoItem(i) {
        let item = null;

        let orgI = this.images.findIndex(img => img?.originalPos == i);
        if (this.images[orgI]) {
            const uploadBox = this.createPhotoUploadBox(i, this.images[orgI]);
            item = uploadBox;
        } else {
            const uploadBox = this.createPhotoUploadBox(i);
            item = uploadBox;
        }

        return item;
    }

    // Resizes an uploaded image while preserving quality and aspect ratio.
    resizeImageToMaxSize(file, maxSize = 4000, bgColor = "#ffffff") {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const url = URL.createObjectURL(file);
            img.onload = () => {
            let { width, height } = img;

            // ---------------------------
            // NORMAL RESIZED IMAGE
            // ---------------------------
            const normalScale = Math.min(
                1,
                maxSize / Math.max(width, height)
            );

            const normalW = Math.round(width * normalScale);
            const normalH = Math.round(height * normalScale);

            const normalCanvas = document.createElement("canvas");
            normalCanvas.width = normalW;
            normalCanvas.height = normalH;

            const nctx = normalCanvas.getContext("2d");
            nctx.drawImage(img, 0, 0, normalW, normalH);

            // ---------------------------
            // CONTAIN IMAGE (WHITE PAD)
            // ---------------------------
            const containSize = Math.max(normalW, normalH);

            const containCanvas = document.createElement("canvas");
            containCanvas.width = containSize;
            containCanvas.height = containSize;

            const cctx = containCanvas.getContext("2d");

            // Fill background
            cctx.fillStyle = bgColor;
            cctx.fillRect(0, 0, containSize, containSize);

            // Center image
            const offsetX = (containSize - normalW) / 2;
            const offsetY = (containSize - normalH) / 2;

            cctx.drawImage(
                img,
                offsetX,
                offsetY,
                normalW,
                normalH
            );

            // ---------------------------
            // EXPORT BOTH
            // ---------------------------
            normalCanvas.toBlob((normalBlob) => {
                containCanvas.toBlob((containBlob) => {
                if (!normalBlob || !containBlob) {
                    URL.revokeObjectURL(url);
                    return reject("Canvas export failed");
                }

                const normalFile = new File(
                    [normalBlob],
                    file.name.replace(".", "_normal."),
                    { type: file.type }
                );

                const containFile = new File(
                    [containBlob],
                    file.name.replace(".", "_contain."),
                    { type: file.type }
                );

                URL.revokeObjectURL(url);
                resolve({
                    normal: normalFile,
                    contain: containFile
                });
                }, file.type, 0.95);
            }, file.type, 0.95);
            };

            img.onerror = (err) => {
                URL.revokeObjectURL(url);
                reject(err);
            };

            img.src = url;
        });
    }

    // Image Handling Methods
    async handleFileSelect(i, event) {
        try {
            // Determine source type
            let files = [];

            if (event?.filesUploaded) {
                files = event.filesUploaded.map(f => ({
                    ...f,
                    type: f.mimetype
                }));
            }
            else if (event?.target?.files) {
                files = Array.from(event.target.files)
            }

            if (!files.length) return;

            // Check if any images are already uploaded
            // const hasUploadedImages = this.images.some(img => img !== null);

            const maxUploadLength = Math.min(this.images.length, files.length);
            const emptySlots = this.getEmptySlots();
            for (let j = 0; j < maxUploadLength; j++) {
                if (files.length > 1) {
                    if (emptySlots[j] !== undefined) {
                        this.addLoadingClass(emptySlots[j]);
                    }
                } else {
                    this.addLoadingClass(i);
                }
            }

            this.handleImageUpload(i, files[0]);

            if (event?.target) {
                event.target.value = '';
            }
        } catch (error) {
            console.error(error, "--err--");
            this.removeLoadingClass(i);
        }
    }

    // Helper to get indices of empty slots
    getEmptySlots() {

        const emptySlots = [];
        for (let i = 0; i < this.images.length; i++) {
            if (!this.images[i]) {
                emptySlots.push(i);
            }
        }
        return emptySlots;
    }

    // Restricts all image upload inputs to accept only a single file.
    allowSingleUpload() {
        S$$("input.img-upload").forEach(f => f.multiple = false);
    }
    // Enables multiple file selection on all image upload inputs.
    allowMultiUpload() {
        S$$("input.img-upload").forEach(f => f.multiple = true);
    }

    // Evaluates the current upload state of all image slots and updates the UI.
    checkAllImagesUploaded() {
        const totalCount = this.images.length;
        const uploadedCount = this.images.filter(img => img && img.status === this.IMAGE_STATUS.UPLOADED).length;
        const uploadingCount = this.images.filter(img => img && img.status === this.IMAGE_STATUS.UPLOADING).length;
        const remaining = totalCount - uploadedCount;

        if (remaining !== totalCount) {
            this.allowSingleUpload();
        } else if (remaining === totalCount) {
            this.allowSingleUpload();
        }

        const allUploaded = totalCount > 0 && remaining === 0;

        // const uploadMsg = document.querySelector(".pta_vp__photo-box .upload-msg");
        // if (uploadMsg) {
        //     if (!allUploaded) {
        //         uploadMsg.innerText = `${remaining} Photos Remaining to Upload`;
        //     } else {
        //         uploadMsg.innerText = "";
        //     }
        // }

        const atcBtn = document.querySelector(".pta_st__atc-btn");
        if (atcBtn) {
            if (totalCount === remaining && uploadingCount == 0 && uploadedCount == 0) {
                atcBtn.innerText = "Add to Cart";
                atcBtn.classList.add("disa");
                atcBtn.classList.remove("uploading");
            } else if (!allUploaded) {
                const currentCount = uploadedCount + uploadingCount;
                atcBtn.innerText = `${uploadingCount > 0 ? "Uploading" : "Uploaded"} (${currentCount}/${totalCount})`;
                atcBtn.classList.add("uploading", "disa");
            } else {
                atcBtn.innerText = "Add to Cart";
                atcBtn.classList.remove("uploading", "disa");
            }
        }

        // Manage other buttons (download, etc.)
        // const allUploadedWithoutFileStack = totalCount > 0 && remaining === 0;
        // if (allUploadedWithoutFileStack) {
        //     this.S$Q(".download-caption")?.classList?.remove("disa");
        //     this.S$Q(".download-caption-vizual")?.classList?.remove("disa");
        // } else {
        //     this.S$Q(".download-caption")?.classList?.add("disa");
        //     this.S$Q(".download-caption-vizual")?.classList?.add("disa");
        // }
    }

    // Check PPI for all frames
    checkPPI() {
        const PPIObject = { PPI: [] };
        this.S$$(".frameArt").forEach((frame) => {
            const frameSizeW = frame.dataset.widthInInches;
            const frameSizeH = frame.dataset.heightInInches;
            const ceB = frame.querySelector(".img-box");
            const ceI = frame.querySelector(".img-box img");
            const { scale } = this.getScaleAndRotation(ceI);
            const ceSc = scale;
            const ceNW = ceI.naturalWidth;
            const paperDiagonalInches = Math.sqrt(
                frameSizeW ** 2 + frameSizeH ** 2
            );
            const imageDiagonal = Math.sqrt(
                (parseFloat(window.getComputedStyle(ceB).width) * (1 / ceSc)) ** 2 +
                (parseFloat(window.getComputedStyle(ceB).height) * (1 / ceSc)) ** 2
            );
            const currentPPI = imageDiagonal / paperDiagonalInches;
            PPIObject.PPI.push(currentPPI);
            if (currentPPI <= 70) {
                frame.classList.add("low-ppi");
            } else {
                frame.classList.remove("low-ppi");
            }
        });
        console.groupCollapsed("PPI Per Frame:");
        console.table(PPIObject);
        console.groupEnd();
    }

    // Handles a single image upload for a given slot index.
    async handleImageUpload(i, file) {
        const type = file.type || file.mimetype || file.filetype || "";

        if (!type.startsWith("image/")) return;

        let processedFile = file;
        if (file instanceof File || file instanceof Blob) {
            try {
                let {contain, normal} = await this.resizeImageToMaxSize(file, 4000);
                processedFile = contain || normal;
            } catch (err) {
                console.error("Image resize failed, using original file:", err);
                processedFile = file;
            }
        }

        const loadImage = (src, alreadyUploaded = false) => {
            const img = new Image();
            img.onload = async () => {
                const frameId = await this.generateFrameId();
                const slotContainer = document.querySelector(
                    `#captionGrid [data-index="${i}"] div`
                );
                this.addLoadingClass(i);

                let orgF = this.frames?.find((f) => f?.editPos == i);
                if (!orgF) {
                    console.warn(`No frame found at editPos ${i}`);
                }
                const tempImage = {
                    previewURL: processedFile?.reuploadUrl || src,
                    filestackUrl: alreadyUploaded ? processedFile?.reuploadUrl || src : null,
                    frameId,
                    status: alreadyUploaded
                        ? this.IMAGE_STATUS.UPLOADED
                        : this.IMAGE_STATUS.UPLOADING,
                    scale: "min",
                    rotation: 0,
                    x: 0,
                    y: 0,
                    originalPos: orgF?.originalPos ? orgF.originalPos : i,
                    editPos: i,
                    naturalWidth: img.naturalWidth,
                    naturalHeight: img.naturalHeight,
                    file: processedFile,
                };

                if (!this.photoToArt) {
                    this.photoToArt = this.createPhotoToArtObject({
                        photoToArtId: this.generatePhotoToArtId(),
                        layout: "grid",
                        frames: [],
                    });
                }

                const newFrame = this.createFrameObject({
                    ...tempImage,
                    image: {
                        previewURL: processedFile?.reuploadUrl || src,
                        filestackUrl: alreadyUploaded
                            ? processedFile?.reuploadUrl || src
                            : null,
                        naturalWidth: img.naturalWidth,
                        naturalHeight: img.naturalHeight,
                        status: tempImage.status,
                    },
                    // cssStyles: {
                    //     width: parseFloat(slotContainer.parentElement.parentElement.getAttribute("width")),
                    //     // height: parseFloat(slotContainer.parentElement.parentElement.getAttribute("height")) * 0.75,
                    //     height: parseFloat(slotContainer.parentElement.parentElement.getAttribute("height")),
                    //     top: parseFloat(slotContainer.parentElement.parentElement.getAttribute("y")),
                    //     left: parseFloat(slotContainer.parentElement.parentElement.getAttribute("x")),
                    // },
                    text: {
                        heading: this.photoToArt?.text?.heading || "",
                        hColor: this.photoToArt?.text?.hColor || "#000000",
                        description: this.photoToArt?.text?.description || "",
                        dColor: this.photoToArt?.text?.dColor || "#999999"
                    }
                });

                this.images[i] = tempImage;
                let orgI = this.frames?.findIndex((f) => f?.editPos == i);
                if (orgI == -1) orgI = i;
                this.photoToArt.frames[orgI] = newFrame;
                this.frames[orgI] = newFrame;

                this.updateGState({
                    images: this.images,
                    photoToArt: this.photoToArt,
                    Frames: this.frames,
                });

                this.render();
                setTimeout(() => {
                    this.editpu();
                }, 100);
                // this.checkPPI();

                // If it's already uploaded (Filestack URL), skip upload
                if (alreadyUploaded) {
                    this.checkAllImagesUploaded();
                    return;
                }

                try {
                    const filestackUrl = await this.uploadFrameToFilestack({
                        image: tempImage,
                    });

                    this.images[i] = {
                        ...this.images[i],
                        previewURL: filestackUrl,
                        filestackUrl: filestackUrl,
                        file: null,
                        status: this.IMAGE_STATUS.UPLOADED,
                    };

                    let orgI = this.frames?.findIndex((f) => f?.editPos == i);
                    if (orgI == -1) orgI = i;

                    this.frames[orgI] = {
                        ...this.frames[orgI],
                        image: {
                            ...this.frames[orgI].image,
                            filestackUrl,
                            previewURL: filestackUrl,
                            status: this.IMAGE_STATUS.UPLOADED,
                        },
                    };

                    this.photoToArt.frames[orgI] = {
                        ...this.photoToArt.frames[orgI],
                        image: {
                            ...this.photoToArt.frames[orgI].image,
                            filestackUrl,
                            previewURL: filestackUrl,
                            status: this.IMAGE_STATUS.UPLOADED,
                        },
                    };
                    this.checkAllImagesUploaded();

                    this.updateGState({
                        images: this.images,
                        photoToArt: this.photoToArt,
                        Frames: this.frames,
                    });
                } catch (error) {
                    console.error(`Upload failed for image ${i}:`, error);
                    this.images[i].status = this.IMAGE_STATUS.FAILED;
                    this.frames[i].image.status = this.IMAGE_STATUS.FAILED;
                    this.photoToArt.frames[i].image.status = this.IMAGE_STATUS.FAILED;

                    this.updateGState({
                        images: this.images,
                        photoToArt: this.photoToArt,
                        Frames: this.frames,
                    });
                }
                this.updateGState({
                    images: this.images,
                    photoToArt: this.photoToArt,
                    Frames: this.frames,
                });
            };

            img.src = src;
        };

        if (processedFile instanceof File || processedFile instanceof Blob) {
            // Local file
            // const reader = new FileReader();
            // reader.onload = (e) => loadImage(e.target.result, false);
            // reader.readAsDataURL(file);
            const blobUrl = URL.createObjectURL(processedFile);
            loadImage(blobUrl, false);
        } else if (processedFile.url) {
            // Filestack object
            loadImage(processedFile.url, true);
        } else {
            console.error("Unsupported file format", processedFile);
        }
    }

    // Handles drag-and-drop image upload.
    handleDrop(i, event) {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type.startsWith('image/')) {
            this.handleImageUpload(i, file);
        }
    }

    //  Updates the current image's transform (scale/rotation) in the editor.
    updateImageTransform(updates) {
        if (!this.pu.ceI) return;
        const { scale, rotate } = this.getScaleAndRotation(this.pu.ceI);

        // Get current transform values
        const current = {
            rotation: rotate,
            scale: scale,
        };

        // Merge updates
        const newTransform = { ...current, ...updates };

        // Apply new transform
        this.pu.ceI.style.transform = `
            rotate(${newTransform.rotation}deg)
            scale(${newTransform.scale})
        `.replace(/\s+/g, ' ').trim();

        this.sizeAdjustPosition(this.pu.ceF, 1, "onload");
        this.loadImageForEditing();
    }

    // Rotates the currently selected image by a given number of degrees.
    rotateImage(degrees) {
        if (!this.pu.ceI) {
            console.warn('No image element selected for rotation');
            return;
        }

        // Get current rotation from dataset or parse from transform
        const { rotate } = this.getScaleAndRotation(this.pu.ceI);
        const newRotation = rotate + degrees;
        this.pu.rotation = newRotation;
        this.pu.SoRchanged = true;
        this.updateImageTransform({ rotation: newRotation });
    }

    // Toggles grayscale (black & white) filter on the current image.
    applyBlackWhite() {
        const img = this.pu.ceI;
        if (!img) return;

        const isGrayscale = img.style.filter?.includes('grayscale');
        if (isGrayscale) {
            this.updatePopupState({ ceBW: true });
            img.style.filter = 'none';
            img.style.webkitFilter = 'none';
        } else {
            this.updatePopupState({ ceBW: false });
            img.style.filter = 'grayscale(100%)';
            img.style.webkitFilter = 'grayscale(100%)';
        }
        this.pu.SoCchanged = true;
        // img.style.filter = isGrayscale ? 'none' : 'grayscale(100%)';
    }

    // Helper: get rotated bounding box size
    getRotatedSize(width, height, angleDeg) {
        const angle = (angleDeg * Math.PI) / 180;
        const cos = Math.abs(Math.cos(angle));
        const sin = Math.abs(Math.sin(angle));
        return {
            width: width * cos + height * sin,
            height: width * sin + height * cos
        };
    }

    // Adjusts the size and position of an image inside its  container.
    sizeAdjustPosition(frame, Ra4Sc, action, oldWdiFC, oldHdiFC) {
        const ife = frame.querySelector(".img-box img");
        if (!ife || !ife.complete || ife.naturalWidth === 0) {
            return new Promise((resolve) => {
                ife.addEventListener("load", () => {
                    this.sizeAdjustPosition(frame, Ra4Sc, action, oldWdiFC, oldHdiFC);
                    resolve();
                }, { once: true });
            });
        }

        const bfe = frame.querySelector(".img-box");
        const natW = ife.naturalWidth;
        const natH = ife.naturalHeight;
        var oldLeft = parseFloat(ife.style.left) || parseFloat(ife.offsetLeft);
        var oldTop = parseFloat(ife.style.top) || parseFloat(ife.offsetTop);
        const boxw = bfe.clientWidth;
        const boxh = bfe.clientHeight;
        const { scale: crSc, rotate } = this.getScaleAndRotation(ife);
        Ra4Sc = Ra4Sc || 1;
        let curentScales = crSc ? crSc * Ra4Sc : 0;

        let minScaleX, minScaleY;
        // if (this.pu.posrotation == "v") {
        //     minScaleX = (boxw * 1.02) / natH;
        //     minScaleY = (boxh * 1.02) / natW;
        // } else {
        //     minScaleX = (boxw * 1.02) / natW;
        //     minScaleY = (boxh * 1.02) / natH;
        // }

        const rotatedSize = this.getRotatedSize(natW, natH, rotate);
        minScaleX = (boxw * 1.02) / rotatedSize.width;
        minScaleY = (boxh * 1.02) / rotatedSize.height;

        curentScales = ife.dataset.scale === "more" ?
            Math.max(curentScales, Math.max(minScaleX, minScaleY)) :
            Math.max(minScaleX, minScaleY);

        ife.style.transform = `rotate(${rotate}deg) scale(${curentScales})`;
        if (crSc > 0 && action != "PageLoad") {
            if (action === "shape") {
                const NEWelWCe = (natW - boxw) / 2;
                const NEWelHCe = (natH - boxh) / 2;
                const WdiFC = (oldWdiFC / crSc) * curentScales;
                const HdiFC = (oldHdiFC / crSc) * curentScales;

                let bigLeft = -NEWelWCe + WdiFC;
                let bigTop = -NEWelHCe + HdiFC;
                ife.style.left = `${bigLeft}px`;
                ife.style.top = `${bigTop}px`;
            } else {
                let newScale = parseFloat(curentScales);
                let curentScale = parseFloat(crSc);
                let newScaleDifrence = 1 - newScale;
                let mnwXsd = (ife.naturalWidth * newScaleDifrence) / 2;
                let mnhXsd = (ife.naturalHeight * newScaleDifrence) / 2;
                let curentScaleDifrence = 1 - curentScale;
                let pnwXsd = (ife.naturalWidth * curentScaleDifrence) / 2;
                let pnhXsd = (ife.naturalHeight * curentScaleDifrence) / 2;
                let pwdis = pnwXsd + oldLeft;
                let phdis = pnhXsd + oldTop;
                let mwdis = (pwdis / curentScale) * newScale;
                let mhdis = (phdis / curentScale) * newScale;
                let bigLeft = -mnwXsd + mwdis;
                let bigTop = -mnhXsd + mhdis;
                ife.style.left = `${bigLeft}px`;
                ife.style.top = `${bigTop}px`;
            }
        }

        const imgRect = ife.getBoundingClientRect();
        const frameRect = bfe.getBoundingClientRect();
        const safeWMargin = bfe.clientWidth * 0.01;
        const safeHMargin = bfe.clientHeight * 0.01;

        let bigLeft = parseFloat(ife.style.left || ife.offsetLeft);
        let bigTop = parseFloat(ife.style.top || ife.offsetTop);

        if (imgRect.left > frameRect.left - safeWMargin) {
            bigLeft = frameRect.left - imgRect.left - safeWMargin + ife.offsetLeft;
        }
        if (imgRect.top > frameRect.top - safeHMargin) {
            bigTop = frameRect.top - imgRect.top - safeHMargin + ife.offsetTop;
        }
        if (imgRect.right < frameRect.right + safeWMargin) {
            bigLeft = frameRect.right - imgRect.right + safeWMargin + ife.offsetLeft;
        }
        if (imgRect.bottom < frameRect.bottom + safeHMargin) {
            bigTop = frameRect.bottom - imgRect.bottom + safeHMargin + ife.offsetTop;
        }

        ife.style.left = `${bigLeft}px`;
        ife.style.top = `${bigTop}px`;
    }

    getScale(element) {
        const computedStyle = window.getComputedStyle(element).transform;

        if (computedStyle === "none") return 1;

        const matrixMatch = computedStyle.match(/matrix\(([^)]+)\)/);
        if (!matrixMatch) {
            console.warn("Transform not in expected matrix format:", computedStyle);
            return 1;
        }

        const matrixValues = matrixMatch[1].split(',').map(v => parseFloat(v.trim()));
        const scaleX = matrixValues[0];
        const scaleY = matrixValues[3];
        return scaleX;
    }

    //  Extracts the current scale and rotation (in degrees) from a transformed element.
    getScaleAndRotation(element) {
        const computedStyle = window.getComputedStyle(element).transform;

        if (computedStyle === "none") {
            return { scale: 1, rotate: 0 };
        }

        const matrixMatch = computedStyle.match(/matrix\(([^)]+)\)/);
        if (!matrixMatch) {
            console.warn("Transform not in expected 2D matrix format:", computedStyle);
            return { scale: 1, rotate: 0 };
        }

        const values = matrixMatch[1].split(',').map(v => parseFloat(v.trim()));
        const [a, b, c, d] = values;

        // scaleX = sqrt(a² + b²)
        const scaleX = Math.sqrt(a * a + b * b);
        // scaleY = sqrt(c² + d²)
        const scaleY = Math.sqrt(c * c + d * d);

        // rotation in radians = atan2(b, a)
        const rotationRad = Math.atan2(b, a);
        const rotationDeg = rotationRad * (180 / Math.PI);

        return { scale: scaleX, rotate: rotationDeg };
    }

    // Popup Editor Methods
     editpu(e) {
        this.pu = this.getDefaultPu();
        this.pu.isOpen = true;
        const ci = this.S$Q(".frameArt");
        if (!ci) {
            console.warn("Frame not found for edit");
            return;
        };

        const el = this.S$Q('.pta_epu-body .frame');
        if (el) {
            el.remove();
        }

        if(this.S$$(".pafp").length > 0) this.S$$(".pafp").forEach(el => el.classList.add("body-lock"));
        const popupState = this.pu;
        // const edi = ci.parentElement.parentElement.getAttribute("data-index");
        popupState.cuF = ci;
        popupState.cuB = ci.querySelector(".img-box");
        popupState.cuI = ci.querySelector(".img-box img");
        popupState.cuHeight = parseInt(this.photoToArt.height, 10);
        popupState.cuWidth = parseInt(this.photoToArt.width, 10);
        popupState.cuSize = `${popupState.cuWidth}x${popupState.cuHeight}`;
        const { scale, rotate } = this.getScaleAndRotation(popupState.cuI)
        popupState.cuScale = scale || 1;
        popupState.zmSlider = this.S$G('SCRzoomSlider');
        popupState.image = popupState.cuI?.getAttribute("src");
        const isGrayscale = popupState.cuI.style.filter?.includes('grayscale');
        popupState.cuBW = isGrayscale;

        let sci;
        try {
            sci = ci.cloneNode(true);
            sci.classList.add("no-transition");
            popupState.ceF = sci;
            popupState.ceF.classList.remove("absolute");
            popupState.ceF.style.position = "unset";
            popupState.ceB = sci.querySelector(".img-box");
            popupState.ceI = sci.querySelector(".img-box img");
            popupState.ceNH = popupState.ceI.naturalHeight;
            popupState.ceNW = popupState.ceI.naturalWidth;
            popupState.ceWidth = popupState.cuWidth;
            popupState.ceHeight = popupState.cuHeight;
            popupState.ceSize = popupState.cuSize;
            popupState.ceScale = popupState.ceHeight / parseFloat(ci.style.height);
            popupState.ceBW = popupState.cuBW

            for (const img of sci.querySelectorAll("img")) {
                if (!img.complete || img.naturalWidth === 0) throw new Error();
            }
        } catch (err) {
            console.warn(err.message);
            return;
        }

        const heightInInches = parseInt(this.photoToArt.height, 10);
        const widthInInches = parseInt(this.photoToArt.width, 10);
        let widthPx, heightPx, scp, maxW, maxH;

        if (this.dType == "D") {
            maxW = 450;
            maxH = 320;
            scp = 320 / parseInt(window.getComputedStyle(ci).height);
            widthPx = parseFloat(window.getComputedStyle(ci).width) * scp;
            heightPx = parseFloat(window.getComputedStyle(ci).height) * scp;
        } else {
            maxW = window.innerWidth * 0.8;
            // maxH = window.innerHeight * 0.5;
            maxH = this.ui.editMidAreaAvail || window.innerHeight * 0.5;
            // let widthPx, heightPx;
            const ratio = widthInInches / heightInInches;

            if (maxW / maxH > ratio) {
                heightPx = maxH;
                widthPx = maxH * ratio;
            } else {
                widthPx = maxW;
                heightPx = maxW / ratio;
            }

            scp = heightPx / parseInt(window.getComputedStyle(ci).height);
            widthPx = parseFloat(window.getComputedStyle(ci).width) * scp;
            heightPx = parseFloat(window.getComputedStyle(ci).height) * scp;
        }

        // const sciborder = parseFloat(sci.style.borderWidth) * scp;
        // const scipadding = parseFloat(sci.style.padding) * scp;
        // const varSize = widthInInches < heightInInches ?
        //     `${widthInInches}x${heightInInches}` :
        //     `${heightInInches}x${widthInInches}`;
        sci.classList.add("frameArt");
        sci.style.width = widthPx + "px";
        sci.style.height = heightPx + "px";

        this.S$Q(".pta_epu-body").appendChild(sci);
        this.S$Q(".pta_epu").style.display = "block";
        // this.S$Q(".pta_epu").setAttribute("data-edit-i", edi);

        const pu = popupState;
        const { scale: popupScale, rotate: popupRotate } = this.getScaleAndRotation(pu.ceI);
        this.updatePopupState({
            ceScale: popupScale * scp,
            ceSize: `${widthInInches}x${heightInInches}`,
            cuScale: popupScale,
            rotation: popupRotate
        });

        this.renderItemFromData({
                    frame: sci,
                    parsedMainFrame: {
                        frameHeight: parseFloat(sci.style.height),
                        frameWidth: parseFloat(sci.style.width),
                        borderWidth: parseFloat(0),
                        padding: parseFloat(0),
                        scale: parseFloat(popupScale),
                        rotate: parseFloat(popupRotate),
                        top: parseFloat(pu.ceI.style.top),
                        left: parseFloat(pu.ceI.style.left),
                        bW: pu.ceI.style.filter
                    },
                    widthPx,
                    heightPx,
                    scaleCorrection: scp,
                    applyImgBoxTransform: true,
                    Ra4Sc: 1,
        })

        this.updatePopupState({
            ceLeft: pu.ceI.style.left,
            ceTop: pu.ceI.style.top,
        });

        if (!this.handlersInitialized) {
            this.initHandlers();
        }

        if (popupState.zmSlider) {
            const zoomButtons = this.S$$(".pta_epu-zoom-container button");

            popupState.zmSlider.addEventListener("input", this.boundHandlers.zoomInput, this.dType === "D" ? true : { passive: true });

            const eventType = this.dType === "D" ? "click" : "touchstart";

            zoomButtons.forEach(button => {
                const zmSlider = popupState.zmSlider;
                const handler = (e) => this.boundHandlers.zoomButton(e, zmSlider, button);
                this.boundHandlers.zoomButtonHandlers.set(button, handler);
                button.addEventListener(eventType, handler);
            });
        }

        this.initPopupEventListeners();
        this.loadImageForEditing();
        this.S$Q("body").style.overflowY = "hidden";

        this.updatePopupState({
            ceLeft: pu.ceI.style.left,
            ceTop: pu.ceI.style.top,
        });
        sci.classList.remove("no-transition");
        
        this.openPopupAnimation();
    }

    // Initializes the image editing popup (Sets zoom slider range)
    loadImageForEditing() {
        const pu = this.pu;

        const ceF = pu.ceF;
        const ceB = pu.ceB;
        const ceI = pu.ceI;
        const zmSlider = pu.zmSlider;
        const { ceScale } = pu;
        
        if (!ceF || !ceB || !ceI) {
            throw new Error('Required editing elements not found in popup state');
        }

        const imgRect = ceI.getBoundingClientRect();
        if (pu.ceNW && imgRect.width) {
            const scaleDI = pu.ceNW / imgRect.width;
            const ppiwidth = ((parseFloat(window.getComputedStyle(ceB).width)) * scaleDI) / 8;
        }
        // --- Remove old listeners before adding new ---
        ceF.removeEventListener('mousedown', this.boundHandlers.onStartMouse);
        ceF.removeEventListener('touchstart', this.boundHandlers.onStartTouch);
        ceF.removeEventListener('wheel', this.boundHandlers.onWheel);
        if (zmSlider) zmSlider.removeEventListener('wheel', this.boundHandlers.onWheel);

        ceF.addEventListener('mousedown', this.boundHandlers.onStartMouse);
        if (this.dType === "M") {
            ceF.addEventListener('touchstart', this.boundHandlers.onStartTouch, { passive: true });
        }
        ceF.addEventListener('wheel', this.boundHandlers.onWheel);
        if (zmSlider) zmSlider.addEventListener('wheel', this.boundHandlers.onWheel);

        let minScaleX, minScaleY, boxw, boxh;
        let PopupRatio;

        if (ceF.dataset.widthInInches == pu.cuF.dataset.widthInInches &&
            ceF.dataset.heightInInches == pu.cuF.dataset.heightInInches) {
            PopupRatio = parseInt(ceF.style.height) / parseInt(pu.cuF.style.height);
            boxw = ceB.clientWidth;
            boxh = ceB.clientHeight;
            PopupRatio = 1;
        } else {
            PopupRatio = 1;
            boxw = ceB.clientWidth;
            boxh = ceB.clientHeight;
        }

        pu.posrotation = "h";

        // if (pu.posrotation === "v") {
        //     minScaleX = boxw * 1.02 / pu.ceNW * PopupRatio;
        //     minScaleY = boxh * 1.02 / pu.ceNH * PopupRatio;
        // } else {
        //     minScaleX = boxw * 1.02 / pu.ceNW * PopupRatio;
        //     minScaleY = boxh * 1.02 / pu.ceNH * PopupRatio;
        // }

        const rotatedSize = this.getRotatedSize(pu.ceNW, pu.ceNH, pu.rotation || 0);
        minScaleX = (ceB.clientWidth * 1.02) / rotatedSize.width;
        minScaleY = (ceB.clientHeight * 1.02) / rotatedSize.height;
        let ceMiS = Math.max(minScaleX, minScaleY);
        zmSlider.style.cursor = "pointer";

        const [frameSizeW, frameSizeH] = pu.ceSize.split('x').map(parseFloat);
        const paperDiagonalInches = Math.sqrt(frameSizeW ** 2 + frameSizeH ** 2);
        const imageDiagonal = Math.sqrt(
            ((parseFloat(window.getComputedStyle(ceB).width)) * (1 / pu.ceScale)) ** 2 +
            ((parseFloat(window.getComputedStyle(ceB).height)) * (1 / pu.ceScale)) ** 2
        );

        const currentPPI = imageDiagonal / paperDiagonalInches;
        // if (ceMiS < 1) ceMiS = 1;   
        // ceMiS = 1;   
        if (currentPPI <= 100) {
          const maxZoomOutScale = ceMiS * 1.33;
          this.setSliderRange(ceMiS * 10000, maxZoomOutScale * 10000, ceScale * 10000);
        } else {
          const maxZoomOutScale = ceScale * ((currentPPI * 0.98) / 100);
          const maxZoomOutScaleBU = ceMiS * 1.33;
          const ceMaS = Math.max(ceMiS, maxZoomOutScale, maxZoomOutScaleBU);
          this.setSliderRange(ceMiS * 10000, ceMaS * 10000, ceScale * 10000);
        }

        return {
            frame: ceF,
            box: ceB,
            img: ceI,
            slider: zmSlider,
            currentPPI: currentPPI,
            minScale: ceMiS,
            currentScale: pu.ceScale
        };
    }

    // Updates the zoom slider range and visual background.
    setSliderRange(min, max, val) {
        const zmSlider = this.S$G('SCRzoomSlider');
        val = Math.max(min, Math.min(val, max));
        zmSlider.min = min;
        zmSlider.max = max;
        zmSlider.value = val;
        const percent = ((val - min) / (max - min)) * 100;
        zmSlider.style.background = `linear-gradient(to right, #4A2014 0%, #4A2014 ${percent}%, #F2EAE0 ${percent}%, #F2EAE0 100%)`;
    }

    // Incrementally zooms the image in via the zoom slider.
    zoomIn() { 

      const zmSlider = S$G('SCRzoomSlider');
      var slidev = Math.abs(zmSlider.value) + ((Math.abs(zmSlider.max) - Math.abs(zmSlider.min)) / 50);
      zmSlider.value = slidev;
      zmSlider.dispatchEvent(new Event('input'));
    }

    // Incrementally zooms the image out via the zoom slider.
    zoomOut() {
      const zmSlider = S$G('SCRzoomSlider');
      var slidev = Math.abs(zmSlider.value) - ((Math.abs(zmSlider.max) - Math.abs(zmSlider.min)) / 50);
      zmSlider.value = slidev;
      zmSlider.dispatchEvent(new Event('input'));
    }

    // Handles manual slider changes
    zoomSliderChange(value) {
        const zmSlider = this.S$G('SCRzoomSlider');
        if (!zmSlider) return;

        const min = parseFloat(zmSlider.min);
        const max = parseFloat(zmSlider.max);
        const val = Math.max(min, Math.min(parseFloat(value), max));
        const percent = ((val - min) / (max - min)) * 100;

        zmSlider.style.background = `linear-gradient(to right, #4A2014 0%, #4A2014 ${percent}%, #F2EAE0 ${percent}%, #F2EAE0 100%)`;

        // (heavy logic)
        this.debouncedZoomProcess(value, percent);
    }

    // debouncedZoomProcess = this.debounce(this.zoomProcess.bind(this), 50);
    debouncedZoomProcess = this.throttleWithRaf(this.zoomProcess.bind(this));

    // Heavy zoom processing logic
    zoomProcess(value, percent) {
        const pu = this.pu;
        const ceB = pu.ceB;
        const ceI = pu.ceI;
        const EFC = document.querySelector('.pta_epu');
        const EFrame = document.querySelector('.pta_epu-body .frameArt');

        if (!ceI || !ceB) {
            console.warn('Required editing elements not found for zoom slider');
            return;
        }

        if (ceB) {
          const rect = ceB.getBoundingClientRect();
          const fRect = EFrame.getBoundingClientRect();
          const root = document.documentElement;
          root.style.setProperty('--b-left', `${rect.left}px`);
          root.style.setProperty('--b-top', `${rect.top}px`);
          root.style.setProperty('--p-hinches', `${pu.ceHeight}px`);
          root.style.setProperty('--p-winches', `${pu.ceWidth}px`);
          root.style.setProperty('--b-width', `${rect.width}px`);
          root.style.setProperty('--b-height', `${rect.height}px`);
          root.style.setProperty('--f-width', `${fRect.width}px`);
          root.style.setProperty('--f-height', `${fRect.height}px`);
          const zmrect = this.pu.zmSlider.getBoundingClientRect();
          root.style.setProperty('--zm-left', `${zmrect.left}px`);
          root.style.setProperty('--zm-top', `${zmrect.top}px`);
          root.style.setProperty('--zm-width', `${zmrect.width}px`);
          root.style.setProperty('--zm-height', `${zmrect.height}px`);
          this.updateThumbMask(this.pu.zmSlider);
        }
        
        EFrame.classList.add("no-transition");

        let ceSc = value / 10000;
        const posrotation = pu.posrotation || "h";

        let minScaleX, minScaleY;
        if (posrotation == "v") {
            minScaleX = ceB.clientWidth * 1.02 / pu.ceNH;
            minScaleY = ceB.clientHeight * 1.02 / pu.ceNW;
        } else {
            minScaleX = ceB.clientWidth * 1.02 / pu.ceNW;
            minScaleY = ceB.clientHeight * 1.02 / pu.ceNH;
        }

        const minScale = Math.max(minScaleX, minScaleY);
        const scaleType = percent < 1 ? "min" : "more";
        ceI.dataset.scale = scaleType;
        ceSc = Math.max(ceSc, minScale);

        const { scale, rotate } = this.getScaleAndRotation(ceI);
        const oldScale = scale || 1;

        ceSc = Math.max(ceSc, minScale);
        let newScale = parseFloat(ceSc);

        const boxRect = ceB.getBoundingClientRect();
        const boxCX = boxRect.left + boxRect.width / 2;
        const boxCY = boxRect.top + boxRect.height / 2;

        const imgRect = ceI.getBoundingClientRect();
        const imgCX = imgRect.left + imgRect.width / 2;
        const imgCY = imgRect.top + imgRect.height / 2;

        // Distance from image center to visible center
        const dx = boxCX - imgCX;
        const dy = boxCY - imgCY;

        ceI.style.transform = `rotate(${pu.rotation || 0}deg) scale(${newScale})`;
        
        const scaleFactor = newScale / oldScale;
        const newLeft = parseFloat(ceI.style.left || 0) - dx * (scaleFactor - 1);
        const newTop = parseFloat(ceI.style.top || 0) - dy * (scaleFactor - 1);

        ceI.style.left = `${newLeft}px`;
        ceI.style.top = `${newTop}px`;

        this.adjustPosition(ceI, ceB);

        if (EFrame._removeEditingImgTimeout) {
          clearTimeout(EFrame._removeEditingImgTimeout);
        }

        EFrame._removeEditingImgTimeout = setTimeout(() => {
          EFC.classList.remove('editing-img-container');
          EFrame.classList.remove('editing-img');
          EFrame.classList.remove("no-transition");
          EFrame._removeEditingImgTimeout = null;
        }, 500);

        this.updatePopupState({
            SoPchanged: true,
            ceScale: ceSc
        });
    }

    // Ensures image stays within frame boundaries after zoom or drag
    adjustPosition(ceI, ceB) {
        const imgRect = ceI.getBoundingClientRect();
        const frameRect = ceB.getBoundingClientRect();
        const safeWMargin = ceB.clientWidth * 0.01;
        const safeHMargin = ceB.clientHeight * 0.01;

        let parsedLeft = parseFloat(ceI.style.left);
        let parsedTop = parseFloat(ceI.style.top);

        let newLeft = Number.isNaN(parsedLeft) ? ceI.offsetLeft : parsedLeft;
        let newTop = Number.isNaN(parsedTop) ? ceI.offsetTop : parsedTop;

        if (imgRect.left > (frameRect.left - safeWMargin)) {
            newLeft = (frameRect.left - imgRect.left - safeWMargin) + ceI.offsetLeft;
        }
        if (imgRect.top > (frameRect.top - safeHMargin)) {
            newTop = (frameRect.top - imgRect.top - safeHMargin) + ceI.offsetTop;
        }
        if (imgRect.right < (frameRect.right + safeWMargin)) {
            newLeft = frameRect.right - imgRect.right + safeWMargin + ceI.offsetLeft;
        }
        if (imgRect.bottom < (frameRect.bottom + safeHMargin)) {
            newTop = frameRect.bottom - imgRect.bottom + safeHMargin + ceI.offsetTop;
        }

        ceI.style.left = `${newLeft}px`;
        ceI.style.top = `${newTop}px`;

        this.updatePopupState({
            ceLeft: newLeft,
            ceTop: newTop
        });
    }

    // Global click handler for popup actions using data-action attributes
    _handleDocumentClick(e) {
        const actionElement = e.target.hasAttribute('data-action') ?
            e.target :
            e.target.closest('[data-action]');
        if (!actionElement) return;

        const action = actionElement.getAttribute('data-action');
        if (action === 'popup-menu') {
            this.handlePopupMenuClick(e, actionElement);
        } else if (action === 'popup-selection') {
            this.handlePopupSelectionClick(e, actionElement);
        } else if (action === 'popup-selection-done') {
            this.handlePopupSelectionDone();
        } else if (action === 'popup-done') {
            this.endSEdit();
        } else if (action === 'popup-cancel') {
            this.handlePopupCancel();
        } else if (action === "edit") {
            const value = actionElement.getAttribute('data-value');
            if (value == "rotate-right") {
                //    this.rotateImage(-90)
            } else if (value == "rotate-left") {
                // this.rotateImage(90)
            } else if (value == "black-white") {

            }
        }
    }

    // Handles actions from the popup menu (delete, crop, size, etc.)
    handlePopupMenuClick(e, actionElement) {
        const target = e.target.closest('[data-value]');
        const value = target.getAttribute('data-value');

        if (value === "delete") {
            const epopup = this.S$Q('.pta_epu');
            const eframe = this.S$Q('.pta_epu-body .frame');
            const cartItem = this.pu.cuF.closest?.("[data-cart-item]");
            cartItem.querySelector("a.cart-remove-link").click();
            setTimeout(() => {
                this.S$Q('.pta_epu-fcurrent')?.classList.remove('pta_epu-fcurrent');
                this.S$Q('.pta_epu-fmain')?.classList.add('pta_epu-fcurrent');
                // this.S$Q('.pta_epu').style.display = "none";
                // this.S$Q('.pta_epu-body .frame')?.remove();.
                this.closePopupAnimation();
            }, 300);
        } else {
            const p = ".pta_epu-f" + value;
            if (value === "size") {
                // this.renderSizeOptions(".pta_epu-fsize");
            }
            if (p == ".pta_epu-fcrop") this.loadImageForEditing();

            const current = actionElement.closest('.pta_epu-fcurrent');
            if (current) current.classList.remove('pta_epu-fcurrent');

            this.S$Q('.pta_epu-footer').dataset.active = p;
            actionElement.closest('.pta_epu')?.querySelector(p)?.classList.add('pta_epu-fcurrent');
            this.setupDefaultValue(value, p, actionElement);
        }
    }

    // Handles selection clicks inside a popup 
    handlePopupSelectionClick(e, actionElement) {
        const target = e.target.closest('[data-value]');
        const container = e.target.closest('[data-category]');
        if (!target || !container) return;

        const category = container.getAttribute('data-category');
        const value = target.getAttribute('data-value');
        // this.updateSelectedValuePopup(container, target, category, value);
    }

    // Handles the "Done" action for popup selections
    handlePopupSelectionDone() {
        this.S$Q('.pta_epu-fcurrent')?.classList.remove('pta_epu-fcurrent');
        this.S$Q('.pta_epu-fmain')?.classList.add('pta_epu-fcurrent');
        this.S$Q('.pta_epu-footer').dataset.active = "pta_epu-fmain";
        this.loadImageForEditing();
    }

    // Handles cancel action for popup
    handlePopupCancel() {
        this.S$Q('.pta_epu-fcurrent')?.classList.remove('pta_epu-fcurrent');
        this.S$Q('.pta_epu-fmain')?.classList.add('pta_epu-fcurrent');
        this.S$Q('.pta_epu-footer').dataset.active = "pta_epu-fmain";
        // this.S$Q('.pta_epu').style.display = "none";
        // this.S$Q('.pta_epu-body .frameArt')?.remove();
        this.removePopupListeners();
        this.closePopupAnimation();
    }

    // Initializes all event handlers (mouse, touch, zoom, rotation, filters) for the popup editor
    initHandlers() {
        if (this.handlersInitialized) return; // Prevent double initialization

        // Mouse & touch drag start
        this.boundHandlers.onStartMouse = (e) => this.onStart(e);
        this.boundHandlers.onStartTouch = (e) => this.onStart(e);

        // Mouse wheel zoom
        this.boundHandlers.onWheel = (e) => {
            e.preventDefault();
            if (e.deltaY < 0) this.zoomIn(e);
            else this.zoomOut(e);
        };

        // Drag move and end
        this.boundHandlers.move = this.onMove.bind(this);
        this.boundHandlers.end = this.onEnd.bind(this);

        // Pinch gestures for touch devices
        this.boundHandlers.touchStart = this.handlePinchStart.bind(this);
        this.boundHandlers.touchMove = this.onMove.bind(this);
        this.boundHandlers.touchEnd = this.onEnd.bind(this);

        // Zoom buttons & input
        this.boundHandlers.zoomButton = this.onZoomButtonClick.bind(this);
        this.boundHandlers.zoomInput = this.onZoomInput.bind(this);

        // Rotate left/right buttons
        this.boundHandlers.rotateLeft = (e) => {
            e.stopPropagation();
            this.rotateImage(-90);
        };
        this.boundHandlers.rotateRight = (e) => {
            e.stopPropagation();
            this.rotateImage(90);
        };

        // Black & white filter button
        this.boundHandlers.blackWhite = (e) => {
            e.stopPropagation();
            this.applyBlackWhite();
        };

        this.handlersInitialized = true;
    }

    // Handles start of drag (mouse or touch) for moving image inside the popup
    onStart(event) {
        if (this.dType == "D") event.preventDefault();
        if (!this.handlersInitialized) {
            this.initHandlers();
        }

        const EFimg = document.querySelector('.pta_epu-body img');
        const EFbox = document.querySelector('.pta_epu-body .img-box');
        const EFC = document.querySelector('.pta_epu');
        const EFrame = document.querySelector('.pta_epu-body .frameArt');
        const zmSlider = this.S$G('SCRzoomSlider');

        if (!EFimg || !EFbox) {
            console.warn('Required editing elements not found for drag start');
            return;
        }

        // Only clear the timeout if zoomSliderChange is running, otherwise don't remove editing-img class here
        if (EFrame._removeEditingImgTimeout) {
          clearTimeout(EFrame._removeEditingImgTimeout);
          EFrame._removeEditingImgTimeout = null;
        } 
        EFC.classList.add('editing-img-container');
        EFrame.classList.add('editing-img');

        // Use popup state if available, fallback to DOM queries
        const pu = this.pu;

        if (EFbox) {
          const rect = EFbox.getBoundingClientRect();
          const fRect = EFrame.getBoundingClientRect();
          const root = document.documentElement;
          root.style.setProperty('--b-left', `${rect.left}px`);
          root.style.setProperty('--b-top', `${rect.top}px`);
          root.style.setProperty('--p-hinches', `${pu.ceHeight}px`);
          root.style.setProperty('--p-winches', `${pu.ceWidth}px`);
          root.style.setProperty('--b-width', `${rect.width}px`);
          root.style.setProperty('--b-height', `${rect.height}px`);
          root.style.setProperty('--f-width', `${fRect.width}px`);
          root.style.setProperty('--f-height', `${fRect.height}px`);
          const zmrect = this.pu.zmSlider.getBoundingClientRect();
          root.style.setProperty('--zm-left', `${zmrect.left}px`);
          root.style.setProperty('--zm-top', `${zmrect.top}px`);
          root.style.setProperty('--zm-width', `${zmrect.width}px`);
          root.style.setProperty('--zm-height', `${zmrect.height}px`);
          this.updateThumbMask(this.pu.zmSlider);
        }

        const clientX = event?.clientX || event?.touches[0]?.clientX;
        const clientY = event?.clientY || event?.touches[0]?.clientY;

        this.dragState = {
            startX: clientX,
            startY: clientY,
            initialX: EFimg.offsetLeft,
            initialY: EFimg.offsetTop,
            isDragging: true
        };

        EFimg.style.cursor = 'grabbing';
        
        document.addEventListener('mousemove', this.boundHandlers.move);
        document.addEventListener('mouseup', this.boundHandlers.end);
        document.addEventListener('mouseleave', this.boundHandlers.end);

        // Touch events → explicitly mark them
        document.addEventListener('touchstart', this.boundHandlers.touchStart, { passive: true });
        document.addEventListener('touchmove', this.boundHandlers.touchMove, { passive: true });
        document.addEventListener('touchend', this.boundHandlers.touchEnd, { passive: true });
        document.addEventListener('touchcancel', this.boundHandlers.touchEnd, { passive: true });

    }

    // Handles end of drag (mouse or touch)
    onEnd() {
        this.dragState = { isDragging: false };
        const EFimg = document.querySelector('.pta_epu-body img');
        const EFC = document.querySelector('.pta_epu');
        const EFrame = document.querySelector('.pta_epu-body .frameArt');
        if(EFC) EFC.classList.remove('editing-img-container');
        if (EFrame) {
            EFrame.classList.remove('editing-img');
            EFrame.classList.remove('no-transition');
        }
        if (EFimg) EFimg.style.cursor = 'grab';

        document.removeEventListener('mousemove', this.boundHandlers.move);
        document.removeEventListener('mouseup', this.boundHandlers.end);
        document.removeEventListener('mouseleave', this.boundHandlers.end);

        document.removeEventListener('touchstart', this.boundHandlers.touchStart, { passive: false });
        document.removeEventListener('touchmove', this.boundHandlers.touchMove, { passive: false });
        document.removeEventListener('touchend', this.boundHandlers.touchEnd, { passive: false });
        document.removeEventListener('touchcancel', this.boundHandlers.touchEnd, { passive: false });
    }

    // Handles movement of image during drag or pinch zoom
    onMove(event) {
        if (this.dType == "D") event.preventDefault();
        event.stopPropagation();
        const pu = this.pu;
        const ceI = pu.isOpen ? pu.ceI : document.querySelector('.pta_epu-body img');
        const ceB = pu.isOpen ? pu.ceB : document.querySelector('.pta_epu-body .img-box');
        const zmSlider = this.S$G('SCRzoomSlider');

        if (!ceI || !ceB) return;

        if (event.touches && event.touches.length === 2) {
            this.handlePinchZoom(event, zmSlider);
        } else if (this.dragState?.isDragging) {
            // this.handleDragMovement(event, ceI, ceB);
            // this.debouncedHandleDragMovement(event, ceI, ceB);
            this.throttledHandleDragMovement(event, ceI, ceB);
        }
    }

    // debouncedHandleDragMovement = this.debounce(this.handleDragMovement.bind(this), 10);
    throttledHandleDragMovement = this.throttleWithRaf(this.handleDragMovement.bind(this));

    // Handles pinch-to-zoom gestures on touch devices
    handlePinchZoom(event, zmSlider) {
        if (event.touches.length !== 2) return;

        if (this.dType == "D") event.preventDefault();
        event.stopPropagation();
        const newDistance = this.getTouchDistance(event.touches);

        if (window.initialDistance) {
            const scaleChange = newDistance / window.initialDistance;
            if (typeof window.pinchScale !== 'undefined') window.pinchScale *= scaleChange;
            window.initialDistance = newDistance;

            if (zmSlider) {
                const sliderMin = parseFloat(zmSlider.min);
                const sliderMax = parseFloat(zmSlider.max);
                let newSliderValue = (window.pinchScale - 1) * (sliderMax - sliderMin) + sliderMin;
                newSliderValue = Math.max(sliderMin, Math.min(sliderMax, newSliderValue));

                zmSlider.value = newSliderValue;
                zmSlider.dispatchEvent(new Event('input'));
                this.updatePopupState({ SoPchanged: true });
            }
        }
    }

    // Moves the image based on mouse/touch drag
    handleDragMovement(event, ceI, ceB) {
        const clientX = event.clientX || event.touches[0].clientX;
        const clientY = event.clientY || event.touches[0].clientY;
        const dx = clientX - this.dragState.startX;
        const dy = clientY - this.dragState.startY;
        let newLeft = this.dragState.initialX + dx;
        let newTop = this.dragState.initialY + dy;

        ceI.style.left = `${newLeft}px`;
        ceI.style.top = `${newTop}px`;

        this.updatePopupState({
            SoPchanged: true,
            ceLeft: newLeft,
            ceTop: newTop
        });

        const imgRect = ceI.getBoundingClientRect();
        const frameRect = ceB.getBoundingClientRect();

        let offsetX = 0;
        let offsetY = 0;

        const addedWPercent = frameRect.width * 0.01;
        const addedHPercent = frameRect.height * 0.01;

        if (imgRect.left > (frameRect.left - addedWPercent)) {
            offsetX = frameRect.left - (imgRect.left + addedWPercent);
        } else if (imgRect.right < (frameRect.right + addedWPercent)) {
            offsetX = frameRect.right - (imgRect.right - addedWPercent);
        }

        if (imgRect.top > (frameRect.top - addedHPercent)) {
            offsetY = frameRect.top - (imgRect.top + addedHPercent);
        } else if (imgRect.bottom < (frameRect.bottom + addedHPercent)) {
            offsetY = frameRect.bottom - (imgRect.bottom - addedHPercent);
        }

        if (offsetX !== 0 || offsetY !== 0) {
            newLeft += offsetX;
            newTop += offsetY;
            ceI.style.left = `${newLeft}px`;
            ceI.style.top = `${newTop}px`;

            this.updatePopupState({
                ceLeft: newLeft,
                ceTop: newTop
            });
        }
    }

    // Handles the start of a pinch gesture on touch devices
    handlePinchStart(event) {
        if (event.touches.length === 2) {
            if (this.dType == "D") event.preventDefault();
            event.stopPropagation();
            window.initialDistance = this.getTouchDistance(event.touches);
            if (typeof window.pinchScale === 'undefined') window.pinchScale = 1;
        }
    }

    // Calculates the distance between two touch points
    getTouchDistance(touches) {
        if (touches.length < 2) return 0; // Need at least two touches

        const dx = touches[0].clientX - touches[1].clientX; // Horizontal distance
        const dy = touches[0].clientY - touches[1].clientY; // Vertical distance

        // Use Pythagoras theorem to compute the distance
        return Math.sqrt(dx * dx + dy * dy);
    }

    // Handles zoom in/out button clicks
    onZoomButtonClick(e, zmSlider, button) {
        e.preventDefault();
        const min = parseFloat(zmSlider.min);
        const max = parseFloat(zmSlider.max);
        const currentValue = parseFloat(zmSlider.value);
        const isZoomIn = button.classList.contains("pta_epu-zoom-plus");

        const step = (max - min) * 0.05;
        let newValue = isZoomIn ? currentValue + step : currentValue - step;

        // Clamp the value within min/max range with small margin
        if (newValue <= min + 0.1) {
            newValue = min;
        } else if (newValue >= max - 0.1) {
            newValue = max;
        }

        newValue = parseFloat(Math.max(min, Math.min(newValue, max)).toFixed(2));
        if (Math.abs(newValue - currentValue) < 0.01) return;

        zmSlider.value = newValue;
        this.zoomSliderChange(newValue);
    }

    // Handles direct input changes on the zoom slider
    onZoomInput(e) {
        if (this.dType == "D") e.preventDefault();
        const value = parseFloat(this.pu.zmSlider.value);
        const EFC = document.querySelector('.pta_epu');
        const EFrame = document.querySelector('.pta_epu-body .frameArt');
        EFC.classList.add('editing-img-container');
        EFrame.classList.add('editing-img');
        this.zoomSliderChange(value);
    }

    // Ends the editing session and applies any pending changes
    endSEdit() {
        console.log("🔚 Ending single frame edit");
        try {
            S$$(".frame").forEach(f => f.classList.add("no-transition-end"));
            const pu = this.pu;
            const epopup = this.S$Q(".pta_epu");
            if (!pu.ceI.style.left) {
                pu.ceI.style.left = pu.ceI.offsetLeft + "px";
            }
            if (!pu.ceI.style.top) {
                pu.ceI.style.top = pu.ceI.offsetTop + "px";
            }

            epopup.querySelector(".pta_epu-box").style.overflow = "visible";
            this.createCloneForAnimation();

            pu.ceLeft = parseFloat(pu.ceI.style.left || pu.ceI.offsetLeft);
            pu.ceTop = parseFloat(pu.ceI.style.top || pu.ceI.offsetTop);
            const { scale, rotate } = this.getScaleAndRotation(pu.ceI);
            pu.ceScale = parseFloat(scale);

            this.S$Q(".pta_epu-body .frameArt .img-box")?.classList.add('cimg-loading');

            document.querySelector(".pta_epu .pta_epu-zoom-container")?.style.setProperty("pointer-events", "none");
            // Check if scale or position was changed using popup state
            if (pu.SoPchanged === true || pu.SoRchanged === true || pu.SoCchanged === true) {
                this.AESnP();
                this.updatePopupState({ SoPchanged: false });
            }

            this.S$Q(".pta_epu-body .frameArt .img-box")?.classList.remove('cimg-loading');
            // this.S$Q(".pta_epu").style.display = "none";
            // this.S$Q(".pta_epu-body").innerHTML = "";
            document.querySelector(".pta_epu .pta_epu-zoom-container")?.style.setProperty("pointer-events", "all");
            this.removePopupListeners();

            S$$(".frame").forEach(f => f.classList.remove("no-transition-end"));
            this.closePopupAnimation();
            return true;
        } catch (error) {
            console.error("❌ Error in endSEdit:", error);
            this.S$Q(".pta_epu-body .frameArt .img-box")?.classList.remove('cimg-loading');
            document.querySelector(".pta_epu .pta_epu-zoom-container")?.style.setProperty("pointer-events", "all");
            this.removePopupListeners();
            return false;
        }
    }

    // Apply edits made in the popup to the main preview
    AESnP() {
        console.log("🔄 Frames: Applying edit settings to main preview");

        try {
            // Get popup state
            const pu = this.pu;
            if (!pu.isOpen || !pu.ceF || !pu.cuF) {
                console.warn("⚠️ Popup state not available, using fallback");
                return this.AESnPFallback();
            }

            // Handle border changes
            if (pu.ceF?.dataset.frameBorder != pu.cuF?.dataset.frameBorder) {
                pu.cuF.dataset.frameBorder = pu.ceF.dataset.frameBorder;
                let { widthInInches: fw, heightInInches: fh } = pu.cuF.dataset;
                fw = parseFloat(fw);
                fh = parseFloat(fh);

                const iw = parseFloat(getComputedStyle(pu.cuF).width),
                    ra = iw / fw,
                    ss = Math.min(fw, fh),
                    bs =
                        pu.ceF.dataset.frameBorder == "No Mat"
                            ? ss * 0
                            : pu.ceF.dataset.frameBorder == "Standard"
                                ? ss * 0.1
                                : ss * 0.2,
                    ab = bs * ra;

                // pu.cuF.style.padding = ab + "px";

                // Update cssStyles when padding changes
                const frameId = pu.cuF.dataset.frameId;
                // if (frameId) {
                //     this.updateFrameCssStyles(frameId, {
                //         padding: ab + "px"
                //     });
                // }
            }

            // Use popup state values
            var mw = parseFloat(window.getComputedStyle(pu.cuB).width);
            var pw = parseFloat(window.getComputedStyle(pu.ceB).width);
            var ms = pu.ceScale * (mw / pw);
            pu.cuI.style.transform = `rotate(${pu.rotation}deg) scale(${ms})`;
            pu.cuI.style.filter = pu.ceI.style.filter;
            pu.cuI.dataset.scale = pu.ceI.dataset.scale;

            var newLeft = parseFloat(pu.ceI.style.left);
            var newTop = parseFloat(pu.ceI.style.top);
            var currentMainScale = ms;
            var currentPopupScale = pu.ceScale;
            var msd = 1 - currentMainScale;
            var mnwXsd = (pu.ceNW * msd) / 2;
            var mnhXsd = (pu.ceNH * msd) / 2;
            var psd = 1 - currentPopupScale;
            var pnwXsd = (pu.ceNW * psd) / 2;
            var pnhXsd = (pu.ceNH * psd) / 2;
            var pwdis = pnwXsd + newLeft;
            var phdis = pnhXsd + newTop;
            var mwdis = (pwdis / currentPopupScale) * currentMainScale;
            var mhdis = (phdis / currentPopupScale) * currentMainScale;
            var bigLeft = -mnwXsd + mwdis;
            var bigTop = -mnhXsd + mhdis;

            pu.cuI.style.left = `${bigLeft}px`;
            pu.cuI.style.top = `${bigTop}px`;

            // Update popup state with new main image position
            this.updatePopupState({
                cuLeft: bigLeft,
                cuTop: bigTop,
            });

            const frameId = pu.ceF.dataset.frameId;

            this.updatePhotoToArtState({
                "image.imgStyles.filter": pu.ceI.style.filter,
                "image.imgStyles.scale": ms,
                "image.imgStyles.rotation": pu.rotation,
                "image.imgStyles.left": bigLeft,
                "image.imgStyles.top": bigTop,
                "image.scale": pu.ceI.dataset.scale,
            }, null, frameId);

            console.log(`📐 Scale: ${currentPopupScale} → ${currentMainScale}`);
            console.log(`🎯 Position: (${newLeft}, ${newTop}) → (${bigLeft}, ${bigTop})`);
            return {
                currentPopupScale,
                currentMainScale,
                currentpopupLeft: newLeft,
                currentpopupTop: newTop,
                currentMainLeft: bigLeft,
                currentMainTop: bigTop,
            }
        } catch (error) {
            console.error("❌ Error in Pg.Frames.AESnP:", error);
            this.AESnPFallback();
        }
    }

    // Fallback method for when popup state is not available
    AESnPFallback() {
        try {
            // Fallback: just apply basic scale using global variables
            const mw = parseFloat(window.getComputedStyle(window.cuB).width);
            const pw = parseFloat(window.getComputedStyle(window.ceB).width);
            const ms = this.pu.ceScale * (mw / pw);
            window.cuI.style.transform = `scale(${ms})`;
        } catch (error) {
            console.error("❌ Error in fallback AESnP:", error);
        }
    }

    // Placeholder method to set default value for popup selections
    setupDefaultValue(value, p, actionElement) {
    }

    /**
     * Generates a high-resolution SVG that matches the on-screen appearance
     */
    renderItemFromData({
        frame,
        parsedMainFrame,
        widthPx,
        heightPx,
        scaleCorrection,
        applyImgBoxTransform = true,
        Ra4Sc
    }) {

        const {
            borderWidth,
            padding,
            scale,
            left,
            top,
            rotate = 0,
            dataScale,
            bW,
        } = parsedMainFrame;

        frame.style.width = `${widthPx}px`;
        frame.style.height = `${parseFloat(heightPx)}px`;
        frame.style.padding = `${padding * scaleCorrection}px`;
        // frame.style.borderWidth = `${borderWidth * scaleCorrection}px`;

        const img = frame.querySelector(".img-box img");
        if (applyImgBoxTransform) {
            img.style.transform = `scale(${scale * scaleCorrection}) rotate(${rotate}deg)`;
        }
        const pu = {}
        //   const pu = Pg.Popup.current;
        pu.ceNW = img.naturalWidth;
        pu.ceNH = img.naturalHeight;

        const mainScaleDifference = 1 - scale;
        const mainNaturalWidthXScaleDifference = (pu.ceNW * mainScaleDifference) / 2;
        const mainNaturalHeightXScaleDifference = (pu.ceNH * mainScaleDifference) / 2;

        const newScale = scale * scaleCorrection;
        const popupScaleDifference = 1 - newScale;
        const popupNaturalWidthXScaleDifference = (pu.ceNW * popupScaleDifference) / 2;
        const popupNaturalHeightXScaleDifference = (pu.ceNH * popupScaleDifference) / 2;

        const popupwdis = mainNaturalWidthXScaleDifference + parseFloat(left);
        const popuphdis = mainNaturalHeightXScaleDifference + parseFloat(top);

        const mainwdis = (popupwdis / scale) * newScale;
        const mainhdis = (popuphdis / scale) * newScale;

        const bigLeft = -popupNaturalWidthXScaleDifference + mainwdis;
        const bigTop = -popupNaturalHeightXScaleDifference + mainhdis;

        img.style.left = `${bigLeft}px`;
        img.style.top = `${bigTop}px`;
        img.style.filter = bW;
        this.sizeAdjustPosition(frame, 1, "pageLoad")
    }

    // ================================================================
    // IMAGE PREVIEW & PROCESSING
    // ================================================================

    // Create tracked blob URL
    createBlob(blob, id = null) {
        try {
            if (!blob || typeof blob.size === 'undefined') {
                throw new Error('Invalid blob provided');
            }

            const url = URL.createObjectURL(blob);
            const blobId = id || this._generateBlobId();

            // Track the blob
            const blobInfo = {
                id: blobId,
                blob: blob,
                url: url,
                size: blob.size,
                type: blob.type,
                created: Date.now(),
                accessed: Date.now(),
                accessCount: 0
            };

            this.blobs.set(url, blobInfo);

            // Update metrics
            this.metrics.totalBlobsCreated++;
            this.metrics.totalMemoryUsed += blob.size;
            this.metrics.peakMemoryUsage = Math.max(
                this.metrics.peakMemoryUsage,
                this.metrics.totalMemoryUsed
            );

            // Check memory limits
            // this._checkMemoryLimits();

            console.log(`🔗 Created blob: ${blobId} ${blob.size}`);

            return url;

        } catch (error) {
            console.error('❌ Failed to create blob URL:', error);
            return null;
        }
    }

    // Uploads a single frame's image (original file or preview URL) to Filestack
    async uploadFrameToFilestack(frame) {
        if (!frame.image?.file && !frame.image?.previewURL) {
            throw new Error('No file or preview URL available for upload');
        }

        const client = this.fileStack;
        if (!client) {
            throw new Error('Filestack not available');
        }

        let blob;

        if (frame.image.file) {
            // Use original file if available
            blob = frame.image.file;
        } else if (frame.image.previewURL) {
            // Convert preview URL to blob
            const response = await fetch(frame.image.previewURL);
            if (!response.ok) {
                throw new Error(`Failed to fetch preview image: ${response.statusText}`);
            }
            blob = await response.blob();
        } else {
            throw new Error('No usable image source found');
        }

        // Generate filename
        const timestamp = Date.now().toString(36);
        const randomId = this?.makeId?.(8) || Math.random().toString(36).substr(2, 8);
        const filename = `f_f-${new Date().getMonth() + 1}_${new Date().getFullYear()}-${timestamp}${randomId}`;

        // Create file with proper name
        const fileToUpload = new File([blob], filename, { type: blob.type });

        // Upload to Filestack
        const uploadResult = await client.upload(fileToUpload);

        if (!uploadResult || !uploadResult.url) {
            throw new Error('Upload result invalid');
        }

        return uploadResult.url;
    }

    // General-purpose uploader for Blob/File or URL string
    async uploadToFilestack(urlOrBlob) {
        const client = this.fileStack;
        if (!client) {
            throw new Error('Filestack client not available');
        }

        let blob;

        // Case 1: Direct Blob/File
        if (urlOrBlob instanceof Blob || urlOrBlob instanceof File) {
            blob = urlOrBlob;
        }
        // Case 2: URL string
        else if (typeof urlOrBlob === "string") {
            const response = await fetch(urlOrBlob);
            if (!response.ok) {
                throw new Error(`Failed to fetch image from URL: ${response.statusText}`);
            }
            blob = await response.blob();
        }
        else {
            throw new Error("Invalid input. Expected a Blob/File or URL string.");
        }

        // Generate filename
        const timestamp = Date.now().toString(36);
        const randomId = this?.makeId?.(8) || Math.random().toString(36).substr(2, 8);
        const ext = blob.type.split("/")[1] || "bin";
        const filename = `upload-${new Date().getMonth() + 1}_${new Date().getFullYear()}-${timestamp}${randomId}.${ext}`;

        // Create file with proper name
        const fileToUpload = new File([blob], filename, { type: blob.type });

        // Upload to Filestack
        const uploadResult = await client.upload(fileToUpload);

        if (!uploadResult || !uploadResult.url) {
            throw new Error("Upload failed or returned invalid response");
        }

        return uploadResult.url;
    }

    // Simple async delay utility
    delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    // update counter count
    updateCounter(span, val) {
        const MAX_LEN = 28;
        const used = val.length;
        span.innerText = `${used}/${MAX_LEN}`;
    }

    // Stops a running process (e.g., upload sequence)
    stop() {
        this.isRunning = false;
        console.log('🛑 Upload process stop requested');
    }

    // Generate a unique S3 URL for uploading
    generateS3Url() {
        const baseUrl = "https://ffpf.s3.us-west-1.amazonaws.com/tp/";

        const now = new Date();

        const yy = String(now.getFullYear()).slice(2);
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const hh = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');

        const random = this.generateRandomAlphaNumeric(8);

        const yymm = `${yy}${mm}`;
        const timestamp = `${dd}_${hh}${min}`;
        const fileName = `${timestamp}_${random}`;

        return `${baseUrl}${yymm}/${fileName}`;
    }

    // Generate a random alphanumeric string of given length
    generateRandomAlphaNumeric(length) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }

    // Calculate crop rectangle and visible area for a frame image
    getCropPoints(frame) {
        const ceB = frame.querySelector('.img-box');
        const ceI = frame.querySelector('.img-box img');
        const borderRect = ceB.getBoundingClientRect();
        const imgRect = ceI.getBoundingClientRect();
        const ceNW = ceI.naturalWidth;
        const ceNH = ceI.naturalHeight;
        const fpd = parseFloat(frame.style.padding);

        let { rotate: rotation } = this.getScaleAndRotation(ceI);
        rotation = Math.round(rotation / 90) * 90 % 360;

        // Calculate aspect ratios
        const naturalAspect = ceNW / ceNH;
        const displayedAspect = imgRect.width / imgRect.height;

        let scaleX = ceNW / imgRect.width;
        let scaleY = ceNH / imgRect.height;

        // For rotated cases, we need to swap the scaling factors
        const isRotated90or270 = Math.abs(rotation) === 90 || Math.abs(rotation) === 270;

        if (isRotated90or270) {
            // When rotated 90/270, the displayed width corresponds to natural height
            // and displayed height corresponds to natural width
            scaleX = ceNH / imgRect.width;
            scaleY = ceNW / imgRect.height;
        }

        let x, y, width, height;
        let nx, ny, nwidth, nheight;

        switch (Math.abs(rotation)) {
            case 0:
                x = (borderRect.left - imgRect.left) * scaleX;
                y = (borderRect.top - imgRect.top) * scaleY;
                width = borderRect.width * scaleX;
                height = borderRect.height * scaleY;

                nx = Math.max(0, ((borderRect.left - imgRect.left) - (ceB.clientWidth * 0.01)) * scaleX);
                ny = Math.max(0, ((borderRect.top - imgRect.top) - (ceB.clientHeight * 0.01)) * scaleY);
                nwidth = borderRect.width * scaleX * 1.01;
                nheight = borderRect.height * scaleY * 1.01;
                break;

            case 90:
                x = (borderRect.left - imgRect.left) * scaleX;
                y = (borderRect.top - imgRect.top) * scaleY;
                width = borderRect.width * scaleX;
                height = borderRect.height * scaleY;

                nx = Math.max(0, (borderRect.left - imgRect.left - (ceB.clientWidth * 0.01)) * scaleX);
                ny = Math.max(0, (borderRect.top - imgRect.top - (ceB.clientHeight * 0.01)) * scaleY);
                nwidth = borderRect.width * scaleX * 1.01;
                nheight = borderRect.height * scaleY * 1.01;
                break;

            case 180:
                x = -(imgRect.left - borderRect.left) * scaleX;
                y = -(imgRect.top - borderRect.top) * scaleY;
                width = borderRect.width * scaleX;
                height = borderRect.height * scaleY;

                nx = Math.max(0, (-(imgRect.left - borderRect.left) - (ceB.clientWidth * 0.01)) * scaleX);
                ny = Math.max(0, (-(imgRect.top - borderRect.top) - (ceB.clientHeight * 0.01)) * scaleY);
                nwidth = borderRect.width * scaleX * 1.01;
                nheight = borderRect.height * scaleY * 1.01;
                break;

            case 270:
                x = (borderRect.top - imgRect.top) * scaleX;
                y = (imgRect.right - borderRect.right) * scaleY;
                width = borderRect.height * scaleX;  // height becomes width after rotation
                height = borderRect.width * scaleY;  // width becomes height after rotation

                nx = Math.max(0, (borderRect.top - imgRect.top - (ceB.clientHeight * 0.01)) * scaleX);
                ny = Math.max(0, (imgRect.right - borderRect.right - (ceB.clientWidth * 0.01)) * scaleY);
                nwidth = borderRect.height * scaleX * 1.01;
                nheight = borderRect.width * scaleY * 1.01;
                break;
        }

        let borderScale;
        if (isRotated90or270) {
            borderScale = Math.sqrt(scaleX * scaleY);
        } else {
            borderScale = scaleX;
        }

        frame.dataset.visableCrop = [Math.round(x), Math.round(y), Math.round(width), Math.round(height)].join(',');
        frame.dataset.borderPx = Math.round(fpd * borderScale);
        frame.dataset.crop = [Math.round(nx), Math.round(ny), Math.round(nwidth), Math.round(nheight)].join(',');

        return {
            visibleCrop: [Math.round(x), Math.round(y), Math.round(width), Math.round(height)].join(','),
            borderPx: Math.round(fpd * borderScale),
            crop: [Math.round(nx), Math.round(ny), Math.round(nwidth), Math.round(nheight)].join(',')
        };
    }

    // Add crop parameters to Filestack URL
    addCropToFilestackUrl(url, cor, bpx, rot = 0) {
        let bpxr = Math.round(bpx);
        let coordinates = cor.split(",");
        let parts = url.split("/");
        let handle = parts.pop();
        let baseUrl = parts.join("/");
        rot = ((rot % 360) + 360) % 360;
        let border = bpxr > 0 ? `border=width:${bpxr},color:white/` : '';
        let newUrl = `${baseUrl}/rotate=deg:${rot}/crop=d:[${coordinates[0]},${coordinates[1]},${coordinates[2]},${coordinates[3]}]/${border}${handle}`;
        return newUrl;
    }

    // Adds a Filestack resize transformation to a given URL
    // Ensures the image fits within max x max dimensions while maintaining aspect ratio
    addResizeToFilestackUrl(url, max = 300) {
        if (!url) return url;
        return url.replace(
            "filestackcontent.com/",
            `filestackcontent.com/resize=fit:max,width:${max},height:${max}/`
        );
    }

    // Extracts properties of the main "photoToArt" container 
    // Includes size, padding, scale, rotation, position, and filter info
    getPhotoToArtPropertiesById() {
        try {
            const photoToArtEl = document.querySelector(`#frameArt`);
            if (!photoToArtEl) return {};

            const { id, width, height, size, style,frame } = this.state.photoToArt;
            // Frames inside this photoToArt
            const frameEls = document.querySelectorAll(`#frameArt`);
            const frames = Array.from(frameEls).map(frameEl => {
                const frameHeight = parseFloat(getComputedStyle(frameEl).height);
                const frameWidth = parseFloat(getComputedStyle(frameEl).width);
                const padding = parseFloat(getComputedStyle(frameEl).padding);

                const imgEl = frameEl.querySelector(".img-box img");
                let scale = 1, top = 0, left = 0, rotation = 0, dataScale = "min", bW = false;
                const filter = imgEl.style.filter;
                
                if (imgEl) {
                    const { scale: s, rotate } = this.getScaleAndRotation(imgEl);
                    rotation = rotate;
                    scale = s;
                    top = parseFloat(getComputedStyle(imgEl).top) || imgEl.offsetTop || 0;
                    left = parseFloat(getComputedStyle(imgEl).left) || imgEl.offsetLeft || 0;
                    bW = filter?.includes('grayscale');
                    dataScale = imgEl.dataset.scale || "min";
                }

                return {
                    frameId: frameEl.dataset.frameId,
                    frameHeight,
                    frameWidth,
                    padding,
                    scale,
                    rotation,
                    top,
                    bW,
                    left,
                    dataScale
                };
            });

            return {
                photoToArtId: id,
                photoToArtWidth: width,
                photoToArtHeight: height,
                photoToArtWidthPx: parseFloat(photoToArtEl.style.width),
                photoToArtHeightPx: parseFloat(photoToArtEl.style.height),
                borderWidth: parseFloat(photoToArtEl.style.borderWidth),
                style: style,
                size: size,
                frame: frame,
                frames
            };
        } catch (err) {
            console.warn("⚠️ Could not extract captionProperties:", err);
            return {};
        }
    }

    /**
   * Build frames summary for cart display
   * @returns {boolean} - Success status
   */
    buildFramesSummary() {
        console.log('📊 Building frames summary');

        try {
            // Get all frames and prepare counters
            const FrameArts = document.querySelectorAll('#frameArt:not(.clone-f');

            let totalPrice = 0;
            let frameCount = 0;
            // Calculate totals and group by style
            FrameArts.forEach(frameArt => {
                if (!frameArt) return;

                frameCount++;


                // Get frame details
                const style = frameArt.getAttribute('data-frame-style') || this.photoToArt.style ||'Oak';
                const size = frameArt.getAttribute('data-frame-size') || this.photoToArt.size || '16*12';
                const frame = frameArt.getAttribute('data-frame') || this.photoToArt.frame || 'Framed Prints';
                let frameSelected = frame, sizeSelected = size, styleSelected = style;
                let newSize = null;
                if (this.photoToArt.frame) {
                    if (this.photoToArt.frame === "Framed Prints") {
                        frameSelected = "Framed_photos";
                    } else if (frameSelected === "Canvas Prints") {
                        frameSelected = "Canvas";
                    }
                }

                sizeSelected = this.normalizeSize(sizeSelected)
                newSize = frameSelected === "Canvas" ? `${frameSelected}_${sizeSelected}` : `${frameSelected}_${styleSelected}_${sizeSelected}`;
                this.photoToArtVariantData = this.getVariantData(newSize);

                const captionPrice = parseFloat(this.photoToArtVariantData?.price || 0);
                const hasAcrylic = this.photoToArt.acrylic == true;
                const acrylicPrice = hasAcrylic ? 0 : 0; // Hardcoded price for now

                // Create frame identifier for grouping
                const frameKey = `${style}-${size}-${frame}-${hasAcrylic ? 'acrylic' : 'no-acrylic'}`;

                // Add to total price
                totalPrice += captionPrice + acrylicPrice;
            });

            if(FrameArts.length == 0) {
                const style = this.photoToArt.style ||'Oak';
                const size = this.photoToArt.size || '16*12';
                const frame = this.photoToArt.frame || 'Framed Prints';
                let frameSelected = frame, sizeSelected = size, styleSelected = style;
                let newSize = null;
                if (this.photoToArt.frame) {
                    if (this.photoToArt.frame === "Framed Prints") {
                        frameSelected = "Framed_photos";
                    } else if (frameSelected === "Canvas Prints") {
                        frameSelected = "Canvas";
                    }
                }

                sizeSelected = this.normalizeSize(sizeSelected)
                newSize = frameSelected === "Canvas" ? `${frameSelected}_${sizeSelected}` : `${frameSelected}_${styleSelected}_${sizeSelected}`;
                this.photoToArtVariantData = this.getVariantData(newSize);

                const captionPrice = parseFloat(this.photoToArtVariantData?.price || 0);
                const hasAcrylic = this.photoToArt.acrylic == true;
                const acrylicPrice = hasAcrylic ? 0 : 0; 
                totalPrice += captionPrice + acrylicPrice;
            }

            if (this.photoToArt.variantID != this.photoToArtVariantData?.id) this.updatePhotoToArtState("variantID", this.photoToArtVariantData?.id);

            // Check for bulk discounts
            const discountPercent = window.discountP || 0;
            const discountThreshold = window.discountTH || 0;
            let discountAmount = 0;

            let discountedPrice = totalPrice;
            if (totalPrice >= discountThreshold && discountPercent > 0) {
                discountedPrice = totalPrice * (1 - (discountPercent / 100));
                discountAmount = totalPrice - discountedPrice;
            }

            // Update summary UI
            const subtotalElement = this.S$Q('.pta_st .pta_st_item.subtotal-item');
            const itemSummaryElement = this.S$Q('.pta_st .pta_st_item.item-summary-text');
            const elementAndPrice = this.S$Q('.pta_st_p');
            const headerBox = this.S$Q('.pta_vp__heder-box');
            if (subtotalElement) {
                const subtotalValueElement = subtotalElement.querySelector('.pta_st_item_value.subtotal-value');
                if (subtotalValueElement) {
                    subtotalValueElement.textContent = `$${totalPrice.toFixed(0)}`;
                }
                // subtotalElement.innerHTML = '';
                // const subtotalEl = `
                //     <div class="subtotal-box fl_s_bet">
                //     <div>
                //         <p>SUBTOTAL</p>
                //     </div>
                //     <div>
                //         ${discountAmount > 0 ? `<span class="st_cprice">$${totalPrice.toFixed(0)}</span>` : ''}
                //         <span class="st_fprice">$${discountedPrice.toFixed(2)}</span>
                //     </div>
                //     </div>
                //     ${discountAmount > 0 ? `<div class="inc_save">Includes $${discountAmount.toFixed(2)} deal saving</div>` : ''}
                // `;

                // subtotalElement.insertAdjacentHTML('beforeend', subtotalEl);

                // if(this.dType === "M") this.S$Q(".pta_st__atc-btn").innerHTML = `$${discountedPrice.toFixed(1)} - Add to Cart`;
            }

            if (itemSummaryElement) {
                const summary = `1 x ${this.photoToArt.style} frame, size ${this.photoToArt.size}`;
                const itemSummaryLabel = itemSummaryElement.querySelector('.pta_st_item_label');
                if (itemSummaryLabel) {
                    itemSummaryLabel.textContent = `${summary}`;
                }
            }

            if (elementAndPrice) {
                elementAndPrice.innerHTML = '';
                const name = `1 ${this.photoToArtVariantData.Size.replace("x", '"')} Frames`;
                const price = totalPrice;

                const productEl = `
                    <div class="">
                        <p class="pta_st_p name">${name}</p>
                    </div>
                    <div class="">
                        <span class="st_fprice">$${price.toFixed(2)}</span>
                    </div>
                `;

                // elementAndPrice.insertAdjacentHTML('beforeend', productEl);
            }

            if (headerBox) {
                const priceElement = headerBox.querySelector('.price-top-box span');
                if (priceElement) {
                    priceElement.textContent = `$${totalPrice.toFixed(2)}`;
                }
                // Update only the price
            }
            return true;
        } catch (error) {
            console.error('❌ Error building frames summary:', error);
            return false;
        }
    }

    // Handles the "Add To Cart" button click
    // Prepares all frames, generates cropped URLs, uploads if needed, and adds items to the Shopify cart   
    async performAddToCart(e) {
        e.stopPropagation();
        if (this.addToCartInProcess || this.cartAddSucceeded) return false;

        const a2cbtn = document.querySelector('.pta_st__atc-btn');
        try {
            // Verify all frames have filestack URLs
            const framesWithoutUrls = this.images.filter(image => !image?.filestackUrl);
            if (!this.images.length || framesWithoutUrls.length > 0) {
                console.warn(`⚠️ ${framesWithoutUrls.length} frame(s) missing filestack URLs`);
                return false;
            }

            this.addToCartInProcess = true;

            // Show loading state
            if (a2cbtn) {
                a2cbtn.classList.add('loading');
                a2cbtn.innerText = 'Processing...';
            }

            // Create items array for cart
            const items = [];
            
            const { id: variantID } = this.photoToArtVariantData;
            const { acrylic, acrylicPrice, frame, size, style, id, width, height } = this.state.photoToArt;

            const { frames } = this.state.photoToArt;

            const f = frames[0];
            const { image, id: frameId } = f;

            let croppedUrl = image?.filestackUrl || null;

            try {
                if (image?.filestackUrl) {
                    const frameElm = document.querySelector(`.frameArt[data-frame-id=${frameId}]`);
                    const { crop } = this.getCropPoints(frameElm);
                    image.crop = crop;
                    croppedUrl = this.addCropToFilestackUrl(image.filestackUrl, image.crop, 0, image.imgStyles.rotation);
                }
            } catch (err) {
                console.warn('⚠️ Error generating cropped URL:', err);
            }

            const s3Img = this.generateS3Url();
            const gcsImg = s3Img.replace('https://ffpf.s3.us-west-1.amazonaws.com/', 'https://storage.googleapis.com/pf4ff/');
            let mainPhotoToArtProperties = this?.getPhotoToArtPropertiesById();
            let filter = image?.imgStyles?.filter || '';
            const isBlackAndWhite = filter?.includes('grayscale');

            items.push({
                id: variantID.toString(),
                quantity: 1,
                properties: {
                    "_photoToArtid_": id,
                    "_acrylic_": frame.toLowerCase().includes("framed prints") ? acrylic.toString() : "false",
                    "_acrylicPrice_": 0,
                    "_frame_": frame,
                    "_style_": style,
                    "_size_": size,
                    "_width_": width,
                    "_height_": height,
                    "_varId_": variantID.toString(),
                    "_text_": this.photoToArt.text,
                    "_bw_": isBlackAndWhite.toString(),
                    "_showText_": this.S$G("tbts")?.checked.toString() || "false",
                    "_cutSizePhotoToArtImg_": croppedUrl || frames[0].image.previewURL,
                    "_visPhotoToArtImg_": frames[0].image.previewURL,
                    "_s3Img_": s3Img + ".png",
                    "_s3Pdf_": s3Img + ".pdf",
                    "_gcsImg_": gcsImg + ".png",
                    "_gcsPdf_": gcsImg + ".pdf",
                    "_mainPhotoToArt_": JSON.stringify(mainPhotoToArtProperties),
                }
            });

            console.log('🛒 Prepared items for cart:', items);
            // Add items to cart via AJAX
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ items })
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.description || data.message || 'Unable to add to cart');
            }

            console.log('✅ Items added to cart:', data);
            this.cartAddSucceeded = true;
            await this.clearSavedState();

            if (a2cbtn) {
                a2cbtn.classList.remove('loading');
                a2cbtn.innerText = 'Added To Cart';
            }
            window.location.href = '/cart';

            return true;
        } catch (error) {
            if (a2cbtn) {
                a2cbtn.classList.remove('loading');
                a2cbtn.innerText = 'Try Again';
            }
            console.error('❌ Error adding items to cart:', error);
            return false;
        } finally {
            this.addToCartInProcess = false;
        }
    }

    // Dynamically updates the Add To Cart button text and state based on upload progress
    updateAddToCartButton() {
        const atcBtn = document.querySelector('.pta_st__atc-btn');
        if (!atcBtn) return;

        let atcBtnText;

        if (atcBtn.innerText.indexOf("$") > -1) {
            atcBtnText = atcBtn.innerText;
        } else {
            atcBtnText = "Add To Cart";
        }
        ;

        const state = Pg.State?.data;
        if (!state) return;

        const { computed } = state;
        const { uploadProgress, canAddToCart } = computed;

        // Remove existing classes
        atcBtn.classList.remove('loading', 'uploading', 'disa');

        if (!computed.hasFrames) {
            // No frames
            atcBtn.classList.add('disa');
            atcBtn.innerText = atcBtnText;
            return;
        }

        // Only show uploading state if user has clicked add to cart
        if (this.userTriedAddToCart && (uploadProgress.hasUploading || (uploadProgress.total > 0 && !uploadProgress.isComplete))) {
            // Uploads in progress and user tried to add to cart - keep button enabled
            atcBtn.classList.add('uploading');
            const completed = uploadProgress.completed;
            const total = uploadProgress.total;
            atcBtn.innerText = `Uploading ${completed}/${total}...`;
            return;
        }

        if (uploadProgress.hasFailures) {
            // Has failed uploads
            atcBtn.classList.add('disa');
            atcBtn.innerText = 'Upload Failed - Try Again';
            return;
        }

        if (canAddToCart) {
            // Ready to add to cart - reset flag if uploads are complete
            if (this.userTriedAddToCart && uploadProgress.isComplete) {
                this.userTriedAddToCart = false;
            }
            atcBtn.innerText = atcBtnText;
            return;
        }

        // If we have frames, always keep button enabled (uploads happen in background)
        if (computed.hasFrames) {
            atcBtn.innerText = atcBtnText;
            return;
        }

        // Only disable if no frames at all
        atcBtn.classList.add('disa');
        atcBtn.innerText = atcBtnText;

    }

    updateThumbMask(slider) {
        const rect = slider.getBoundingClientRect();
        const min = parseFloat(slider.min) || 0;
        const max = parseFloat(slider.max) || 100;
        const val = parseFloat(slider.value);
        const percent = (val - min) / (max - min);
        const thumbWidth = 20;
        const thumbBorder = 0;
        const thumbSize = thumbWidth + (thumbBorder * 2);

        // Calculate accurate thumb center position
        const trackWidth = rect.width;
        const thumbHalfSize = thumbSize / 2;
        
        // Account for thumb size in position calculation
        const thumbX = rect.left + thumbHalfSize + (percent * (trackWidth - thumbSize));
        const thumbY = rect.top + rect.height / 2;

        const root = document.documentElement;
        root.style.setProperty('--thumb-center-x', `${thumbX}px`);
        root.style.setProperty('--thumb-center-y', `${thumbY}px`);
        root.style.setProperty('--thumb-radius', `${thumbHalfSize}px`);
    }
    
    openPopupAnimation() {
      const pu = this.pu;
      const popupFrame = pu.ceF;
      const targetFrame = pu.cuF;
      popupFrame.classList.remove('is-animating');
      
      // Get FIRST position (original frame)
      const firstRect = targetFrame.getBoundingClientRect();

      // Make popup frame invisible temporarily
      popupFrame.style.opacity = "0";
      popupFrame.style.transition = "none";
      popupFrame.style.transform = "none";
      popupFrame.style.pointerEvents = "none"
      
      // Force reflow
      popupFrame.offsetHeight;
      
      // Force DOM update
      requestAnimationFrame(() => {
        // Get LAST position
        const lastRect = popupFrame.getBoundingClientRect();

        // Calculate differences
        const deltaX = firstRect.left - lastRect.left;
        const deltaY = firstRect.top - lastRect.top;
        const deltaScaleX = firstRect.width / lastRect.width;
        const deltaScaleY = firstRect.height / lastRect.height;
        
        popupFrame.style.transformOrigin = "top left";
        popupFrame.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${deltaScaleX}, ${deltaScaleY})`;

        popupFrame.style.opacity = "1";

        popupFrame.offsetHeight;
        
        popupFrame.style.transition = "";
        popupFrame.classList.add('is-animating');
        
        popupFrame.style.transform = "translate(0px, 0px) scale(1, 1)";
        
        S$Q(".pta_epu-box").classList.add("show");
        S$Q(".pta_epu").classList.add("show");
      });
      
      // Handle transition end
      const onTransitionEnd = () => {
        popupFrame.removeEventListener('transitionend', onTransitionEnd);
        popupFrame.classList.remove('is-animating');
        popupFrame.style.removeProperty("transform");
        popupFrame.style.removeProperty("transform-origin");
        popupFrame.style.removeProperty("pointer-events");
        S$Q(".pta_epu-box").classList.add("epu-ready");
      };
      
      popupFrame.addEventListener('transitionend', onTransitionEnd, { once: true });

      setTimeout(() => {
        S$Q(".pta_epu-box").classList.add("epu-ready");
      }, 500);
    }

    createCloneForAnimation() {
        const pu = this.pu;
        const targetFrame = pu.cuF;
        const clone = targetFrame.cloneNode(true);
        clone.classList.add("clone-f");
        const rect = targetFrame.getBoundingClientRect();

        clone.style.position = "fixed";
        clone.style.left = rect.left + "px";
        clone.style.top = rect.top + "px";
        clone.style.width = rect.width + "px";
        clone.style.height = rect.height + "px";
        clone.style.margin = "0";
        clone.style.transform = "none";
        clone.style.zIndex = "9999";

        document.body.appendChild(clone);

        // Hide original
        targetFrame.style.opacity = "0";
        targetFrame.style.visibility = "hidden";
    }

    closePopupAnimation(close = false) {
        const pu = this.pu;
        const popupFrame = pu.ceF;
        const targetFrame = pu.cuF;
        
        if (!popupFrame || !targetFrame) return;
        
        S$Q(".pta_epu-box").classList.remove("epu-ready");
        
        const MAX_TIME = 400;
        const useReplica = close === true;
        
        // Determine which element to animate
        const sourceElement = useReplica ? targetFrame.cloneNode(true) : popupFrame;
        const isReplica = useReplica;
        
        if (isReplica) {
            // Setup replica
            sourceElement.classList.add('frame-replica');
            Object.assign(sourceElement.style, {
                position: 'fixed',
                margin: '0',
                zIndex: '9999',
                pointerEvents: 'none',
                transform: 'none',
                transition: 'none'
            });
            
            // Position replica exactly where popup is
            const popupRect = popupFrame.getBoundingClientRect();
            sourceElement.style.top = popupRect.top + 'px';
            sourceElement.style.left = popupRect.left + 'px';
            
            // Hide original popup
            popupFrame.style.opacity = '0';
            popupFrame.style.pointerEvents = 'none';
            
            // Add replica to DOM
            document.body.appendChild(sourceElement);
        } else {
            // Setup original popup for animation
            sourceElement.style.transition = "none";
            sourceElement.style.transformOrigin = "top left";
            sourceElement.style.transform = "translate(0px, 0px) scale(1, 1)";
            sourceElement.offsetHeight;
            sourceElement.style.transition = "";
            sourceElement.classList.add('is-animating');
        }
        
        // Get positions and calculate transforms
        const fromRect = isReplica ? popupFrame.getBoundingClientRect() : popupFrame.getBoundingClientRect();
        const toRect = targetFrame.getBoundingClientRect();
        
        const deltaX = toRect.left - fromRect.left;
        const deltaY = toRect.top - fromRect.top;
        let deltaScaleX = toRect.width / fromRect.width;
        let deltaScaleY = toRect.height / fromRect.height;
        
        // Force reflow for replica
        if (isReplica) {
            sourceElement.offsetHeight;
            sourceElement.style.transition = 'all 0.3s ease-in-out';
            sourceElement.style.transformOrigin = 'top left';
            deltaScaleX = 1;
            deltaScaleY = 1;
        }
        
        // Apply transform
        sourceElement.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${deltaScaleX}, ${deltaScaleY})`;
        
        S$Q(".pta_epu-box").style.backgroundColor = "rgba(255, 255, 255, 0)";
        if (this.dType === "M") {
            S$Q(".pta_epu").style.backgroundColor = "#11111190";
        }
        
        S$Q(".pta_epu-box").classList.remove("epu-ready");
        S$Q(".pta_epu").classList.remove("show");
        
        // Remove any existing clone
        const existingClone = document.querySelector(".frameArt.clone-f");
        if (existingClone) existingClone.remove();
        
        // Setup cleanup
        let finished = false;
        
        const cleanup = () => {
            if (finished) return;
            finished = true;
            
            if (isReplica) {
                if (sourceElement?.parentNode) {
                    sourceElement.remove();
                }
                // Reset popup styles
                popupFrame.style.removeProperty('opacity');
                popupFrame.style.removeProperty('pointer-events');
            } else {
                popupFrame.removeEventListener("transitionend", onEnd);
                popupFrame.classList.remove('is-animating');
            }
            
            // Common cleanup
            S$Q(".pta_epu-box").style.removeProperty("background-color");
            S$Q(".pta_epu").style.removeProperty("background-color");
            S$Q(".pta_epu").style.removeProperty("display");
            S$Q(".pta_epu-box").style.removeProperty("overflow");
            S$Q(".pta_epu").classList.remove("show");
            S$Q(".pta_epu-box").classList.remove("show");
            S$Q(".pta_epu").style.removeProperty("opacity");
            S$Q(".pta_epu-body").innerHTML = "";
            
            // Show target frame
            targetFrame.style.opacity = "1";
            targetFrame.style.removeProperty("visibility");
        };
        
        const onEnd = (e) => {
            if (e.target !== sourceElement) return;
            if (!isReplica && e.propertyName !== "transform") return;
            cleanup();
        };
        
        sourceElement.addEventListener("transitionend", onEnd, {once: true});
        setTimeout(cleanup, MAX_TIME);
    }

    // Detects if browser is Safari
    isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    // Convert image URL to base64 string
    async urlToBase64(url) {
        const res = await fetch(url, { mode: 'cors' });
        if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
        const blob = await res.blob();
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    // Convert base64 data URL to Blob
    dataURLtoBlob(dataUrl) {
        const arr = dataUrl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    }

    // Convert File/Blob to base64
    toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }
}


document.addEventListener("DOMContentLoaded", () => {
    window.s = new FrameForestApp();
});
